import React, { useState, useRef, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import * as XLSX from "xlsx";
import { BASE_URL, IMAGE_URL } from "../config/axios";
import { axiosInstance, axiosInstance2 } from "../config/axiosInstance";
import { Attachment, DocumentIcon, Eye, PDFIcon, Calender, LockButton, UnLockButton, ImageIcon, DOCIcon, EXCELIcon, VideoIcon } from "./AllSvg";
import { DatePicker, Button, Space } from "antd";

import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";
import { formattedDateLong } from "./Date";
import { AlertCircle, Check, Clock, LockIcon, UnlockIcon, X } from "lucide-react";
const { RangePicker } = DatePicker;

const toOrdinal = (n) => {
    const s = ["th", "st", "nd", "rd"];
    const v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
};

const getFileExtension = (url) => {
    if (!url) return "";
    return url.split(".").pop()?.toLowerCase().split(/\#|\?/)[0] || "";
};

const isImage = (url) => {
    return /\.(jpg|jpeg|png|gif|bmp|webp)(\?.*)?$/.test(url);
}


// const DateRangePicker = ({ startDate, endDate, onChange, placeHolder1, placeHolder2 }) => {
//     const [dates, setDates] = useState([null, null]);

//     const handleRangeChange = (values) => {
//         if (!values || values.length !== 2) {
//             setDates(null);
//             onChange(null, null);
//             return;
//         }

//         setDates(values);
//         onChange(values[0].format("YYYY-MM-DD"), values[1].format("YYYY-MM-DD"));
//     };


//     return (
//         <div>
//             <Calender />
//             <Space direction="vertical" size={12} style={{ color: "#707070" }}>
//                 <RangePicker
//                     key={dates ? dates.toString() : "empty"}
//                     value={dates}
//                     placeholder={[placeHolder1, placeHolder2]}
//                     onChange={handleRangeChange}
//                     className="custom-range-picker"
//                 />

//             </Space>
//         </div>
//     );
// };



const DateRangePicker = ({ startDate, endDate, onChange, placeHolder1, placeHolder2 }) => {
    const [dates, setDates] = useState([null, null]);

    const handleRangeChange = (values) => {
        if (!values || values.length !== 2) {
            setDates([null, null]);
            onChange(null, null);
            return;
        }
        setDates(values);
        onChange(values[0].format("YYYY-MM-DD"), values[1].format("YYYY-MM-DD"));
    };

    return (
        <div style={{ width: "100%" }} className="date-range-wrapper ">

            <Space direction="vertical" size={0} style={{ width: "100%" }}>
                <RangePicker
                    value={dates}
                    placeholder={[placeHolder1, placeHolder2]}
                    onChange={handleRangeChange}
                    className={`custom-range-picker`}
                    style={{ width: "100%", height: '38px !important', padding: " 8px 12px !important" }}
                />

            </Space>

        </div>
    );
};

export default DateRangePicker;


const handleErrorToast = (err, loadingToastId = null) => {
    if (loadingToastId) {
        toast.dismiss(loadingToastId);
    }

    if (err.response) {
        const errorData = err.response.data;

        // Case 1: Handle structured error with status + message
        if (errorData.status === 'error' && typeof errorData.message === 'string') {
            toast.error(`Error: ${errorData.message}`);
        }
        // Case 2: Generic message field
        else if (errorData.message) {
            toast.error(`Error: ${errorData.message}`);
        }
        // Case 3: Detailed token messages
        else if (errorData.detail && errorData.messages) {
            const detail = errorData.detail;
            const code = errorData.code;
            const messages = errorData.messages;

            toast.error(`Error: ${detail} (Code: ${code})`);

            messages.forEach(messageObj => {
                const tokenClass = messageObj.token_class || 'Unknown Token';
                const tokenType = messageObj.token_type || 'Unknown Type';
                const message = messageObj.message || 'Unknown Error';

                toast.error(`Token Class: ${tokenClass}, Type: ${tokenType} - ${message}`);
            });
        }
        // Case 4: Simple string error
        else if (typeof errorData.error === 'string') {
            toast.error(`Error: ${errorData.error}`);
        }
        // ✅ Case 5: Array of field errors (e.g. your tender_id case)
        else if (Array.isArray(errorData) && errorData.every(item => typeof item === 'object')) {
            errorData.forEach(errorObj => {
                Object.entries(errorObj).forEach(([field, messages]) => {
                    messages.forEach(message => toast.error(`"${field}": ${message}`));
                });
            });
        }
        // Case 6: Object of field errors
        else if (typeof errorData === 'object' && errorData !== null) {
            Object.entries(errorData).forEach(([field, messages]) => {
                if (Array.isArray(messages)) {
                    messages.forEach(message => toast.error(`"${field}": ${message}`));
                } else {
                    toast.error(`"${field}": ${messages}`);
                }
            });
        }
        // Case 7: HTML error page
        else if (typeof errorData === 'string' && errorData.includes("<html")) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(errorData, "text/html");
            const pageTitle = doc.querySelector("title")?.innerText || 'Unknown Error';
            toast.error(`Error: ${pageTitle}`);
        }
        // Default fallback
        else {
            console.log("handleAllError fallback:");
            console.log(err);
            toast.error('Error: Failed to Process!');
        }
    } else {
        console.log("err : handleAllError (no response)");
        console.log(err);
        toast.error('Error processing your request.');
    }
};
const isEditable = (dateString) => {
    if (!dateString) return false;

    const createdAt = new Date(dateString); // keeps time
    const now = new Date();

    const diffMs = now - createdAt;
    const hoursPassed = diffMs / (1000 * 60 * 60);

    return hoursPassed > 24;
};



const getMonthOptionss = () => {
    return [
        { id: "null", name: "Select Month" },
        { id: "01", name: "January" },
        { id: "02", name: "February" },
        { id: "03", name: "March" },
        { id: "04", name: "April" },
        { id: "05", name: "May" },
        { id: "06", name: "June" },
        { id: "07", name: "July" },
        { id: "08", name: "August" },
        { id: "09", name: "September" },
        { id: "10", name: "October" },
        { id: "11", name: "November" },
        { id: "12", name: "December" },
    ];
};



const monthOptions = [
    { id: "01", name: "January" },
    { id: "02", name: "February" },
    { id: "03", name: "March" },
    { id: "04", name: "April" },
    { id: "05", name: "May" },
    { id: "06", name: "June" },
    { id: "07", name: "July" },
    { id: "08", name: "August" },
    { id: "09", name: "September" },
    { id: "10", name: "October" },
    { id: "11", name: "November" },
    { id: "12", name: "December" },
];

const getMonthName = (monthNumber) => {
    const paddedMonth = String(monthNumber).padStart(2, '0');
    const month = monthOptions.find((m) => m.id === paddedMonth);
    return month ? month.name : "";
};


const calculateTotal = (data, getFieldValue) => {
    return data.reduce((total, item) => {
        return total + Number(getFieldValue(item));
    }, 0);
};

const getProgressColor = (percentage) => {
    // if (percentage < 10) return '#ff747c';
    if (percentage < 33) return '#ff747c';
    if (percentage < 66) return '#f7ba1e';
    return '#06ad06';
};


const ProgressModal = ({ show, progress, usedFor }) => {
    const color =
        usedFor === "Add" ? "#16a34a" :
            usedFor === "Update" ? "#f7941e" :
                usedFor === "Delete" ? "#f72b50" :
                    usedFor === "Reject" ? "#f72b50" : "#3b82f6";

    // Helper function to get icon based on action
    const getIcon = () => {
        switch (usedFor) {
            case "Add": return "📤";
            case "Update": return "🔄";
            case "Delete": return "🗑️";
            case "Reject": return "X";
            default: return "";
        }
    };

    // Helper function to get action text
    const getActionText = () => {
        switch (usedFor) {
            case "Add": return "Uploading";
            case "Update": return "Updating";
            case "Delete": return "Deleting";
            default: return "";
        }
    };

    return (
        <Modal show={show} backdrop="static" keyboard={false} centered>
            <Modal.Header className="border-0 pb-0">
                <Modal.Title
                    className="text-center w-100"
                    style={{
                        color,
                        fontWeight: "600",
                        fontSize: "1.5rem",
                        letterSpacing: "0.5px"
                    }}
                >
                    <div className="d-flex align-items-center justify-content-center gap-2">
                        <span style={{ fontSize: "2rem" }}>{getIcon()}</span>
                        <span>{getActionText()}</span>
                        <span
                            style={{
                                fontSize: "1.8rem",
                                fontWeight: "700",
                                color,
                                opacity: 0.9
                            }}
                        >
                            {progress}%
                        </span>
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="pt-2 pb-4">
                <div className="position-relative">
                    {/* Background track */}
                    <div
                        style={{
                            width: "100%",
                            height: "12px",
                            backgroundColor: "#f0f0f5",
                            borderRadius: "10px",
                            overflow: "hidden",
                            boxShadow: "inset 0 2px 4px rgba(0,0,0,0.06)"
                        }}
                    >
                        {/* Progress fill with animated gradient */}
                        <div
                            style={{
                                width: `${progress}%`,
                                height: "100%",
                                background: `linear-gradient(90deg, 
                                    ${color} 0%, 
                                    ${color}dd 50%, 
                                    ${color} 100%)`,
                                borderRadius: "10px",
                                transition: "width 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                                position: "relative",
                                boxShadow: `0 0 20px ${color}66`
                            }}
                        >
                            {/* Shimmer animation */}
                            <div
                                style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    background: "linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.3) 50%, transparent 100%)",
                                    animation: progress < 100 ? "shimmer 1.5s infinite" : "none",
                                    borderRadius: "10px"
                                }}
                            />
                        </div>
                    </div>

                    {/* Progress label with subtle animation */}
                    <div
                        className="mt-2 text-center"
                        style={{
                            fontSize: "0.85rem",
                            color: "#6b7280",
                            fontWeight: "500",
                            letterSpacing: "0.3px",
                            opacity: progress === 100 ? 1 : 0.8
                        }}
                    >
                        {progress === 100 ? "✅ Complete!" : `${progress}% completed`}
                    </div>
                </div>
            </Modal.Body>

            {/* CSS for shimmer animation */}
            <style>{`
                @keyframes shimmer {
                    0% { transform: translateX(-100%); }
                    100% { transform: translateX(100%); }
                }
                
                .progress-bar-fill {
                    background-size: 200% 100%;
                    animation: progressAnimation 1.5s ease-in-out infinite;
                }
            `}</style>
        </Modal>
    );
};
const Updatebutton = ({ onclick }) => {
    return (
        <>
            <button className="addbuttons" onClick={onclick}>
                <span className="addbuttontext">Update
                </span>
                <span className="addbuttonicon">
                    <svg
                        viewBox="0 0 24 24"
                        height="24"
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M9.707 19.121a.997.997 0 0 1-1.414 0l-5.646-5.647a1.5 1.5 0 0 1 0-2.121l.707-.707a1.5 1.5 0 0 1 2.121 0L9 14.171l9.525-9.525a1.5 1.5 0 0 1 2.121 0l.707.707a1.5 1.5 0 0 1 0 2.121z"
                        ></path>
                    </svg>
                </span>
            </button>


        </>
    )
}
const Addbutton = ({ onclick }) => {
    return (
        <>
            <button className="addbuttons" onClick={onclick} >
                <span className="addbuttontext">Add</span>
                <span className="addbuttonicon"
                ><svg
                    viewBox="0 0 24 24"
                    height="24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                ></svg>
                    <span className="addbuttonsSpan">+</span>
                </span>
            </button>

        </>
    )
}

const DeleteButton = ({ onclick }) => {
    return (
        <>
            <button className="deletesubmitbutton" onClick={onclick} type="submit">
                <span className="deletesubmitbutton__text">Delete</span>
                <span className="deletesubmitbutton__icon">
                    <svg
                        className="svg"
                        height="512"
                        viewBox="0 0 512 512"
                        width="512"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <title>Delete</title>
                        <path
                            d="M112,112l20,320c.95,18.49,14.4,32,32,32H348c17.67,0,30.87-13.51,32-32l20-320"
                            style={{
                                fill: "none",
                                stroke: "#fff",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                strokeWidth: "32px",
                            }}
                        ></path>
                        <line
                            x1="80"
                            y1="112"
                            x2="432"
                            y2="112"
                            style={{
                                stroke: "#fff",
                                strokeLinecap: "round",
                                strokeMiterlimit: 10,
                                strokeWidth: "32px",
                            }}
                        ></line>
                        <path
                            d="M192,112V72h0a23.93,23.93,0,0,1,24-24h80a23.93,23.93,0,0,1,24,24h0v40"
                            style={{
                                fill: "none",
                                stroke: "#fff",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                strokeWidth: "32px",
                            }}
                        ></path>
                        <line
                            x1="256"
                            y1="176"
                            x2="256"
                            y2="400"
                            style={{
                                fill: "none",
                                stroke: "#fff",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                strokeWidth: "32px",
                            }}
                        ></line>
                        <line
                            x1="184"
                            y1="176"
                            x2="192"
                            y2="400"
                            style={{
                                fill: "none",
                                stroke: "#fff",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                strokeWidth: "32px",
                            }}
                        ></line>
                        <line
                            x1="328"
                            y1="176"
                            x2="320"
                            y2="400"
                            style={{
                                fill: "none",
                                stroke: "#fff",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                strokeWidth: "32px",
                            }}
                        ></line>
                    </svg>
                </span>
            </button>
        </>
    )
}

const isMoreThan24Hours = (createdAt) => {
    if (!createdAt) return false;

    const createdTime = new Date(createdAt).getTime(); // Parses UTC correctly
    const now = new Date().getTime();

    const hoursDifference = (now - createdTime) / (1000 * 60 * 60);
    return hoursDifference > 24;
};


const formatRoundoff = (amount) => {
    if (amount === null || amount === undefined) return "-";

    // Function to format the number with Indian number system
    const formatIndianStyle = (num) => {
        let numStr = num.toString();
        let lastThreeDigits = numStr.slice(-3);
        let otherDigits = numStr.slice(0, -3);

        if (otherDigits) {
            lastThreeDigits = "," + lastThreeDigits;
        }

        // Split other digits into groups of two and add commas
        const formattedOtherDigits = otherDigits.replace(
            /\B(?=(\d{2})+(?!\d))/g,
            ","
        );

        return formattedOtherDigits + lastThreeDigits;
    };

    return formatIndianStyle(amount);
};

const formatRoundoffComplete = (amount) => {
    const roundedAmount = Math.round(amount); // Round off to the nearest whole number
    return new Intl.NumberFormat("en-IN", {
        style: "decimal",
        minimumFractionDigits: 0, // No decimal places
        maximumFractionDigits: 0,
    }).format(roundedAmount);
};

const formatRoundoff2D = (amount) => {
    const roundedAmount = amount;
    return new Intl.NumberFormat("en-IN", {
        style: "decimal",
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    }).format(roundedAmount);
};

const formatRoundoff3D = (amount) => {
    const roundedAmount = amount;
    return new Intl.NumberFormat("en-IN", {
        style: "decimal",
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    }).format(roundedAmount);
};

const formatRoundoffCrores = (amount) => {
    if (amount === null || amount === undefined) return "-";

    if (amount < 10000000) {
        return new Intl.NumberFormat("en-IN", {
            maximumSignificantDigits: 21,
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        }).format(amount);
    }
    const amountInCr = amount / 10000000;
    return `${amountInCr.toFixed(2)} Cr`;
};

const formatCurrencyIndian = (amount) => {
    if (amount === null || amount === undefined) return "-";
    const hasDecimals = amount % 1 !== 0;

    return new Intl.NumberFormat("en-IN", {
        maximumSignificantDigits: 21,
        minimumFractionDigits: hasDecimals ? 2 : 0,
        maximumFractionDigits: hasDecimals ? 2 : 0,
    }).format(amount);
};

const formatDateTime = (datetimeStr) => {
    const dateObj = new Date(datetimeStr);

    const day = String(dateObj.getDate()).padStart(2, "0");
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const year = dateObj.getFullYear();

    const dateFormatted = `${day}/${month}/${year}`;
    const timeFormatted = dateObj.toLocaleTimeString();

    const defaultFormat = `${dateFormatted}(${timeFormatted})`;
    return {
        toString: () => defaultFormat,
        full: `${dateFormatted} ${timeFormatted}`,
        date: dateFormatted,
        time: timeFormatted,
    };
};

const formatExcelToJson = (file, dateFields = []) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = (e) => {
            try {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: "array" });

                const sheetName = workbook.SheetNames[0]; // Use the first sheet by default
                const worksheet = workbook.Sheets[sheetName];
                const json = XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: null });

                const headers = json[0];
                const rows = json.slice(1);

                // Function to convert Excel serial number to a date
                const convertExcelDate = (serial) => {
                    const excelEpoch = new Date(1900, 0, 1); // Excel epoch starts on Jan 1, 1900
                    const daysOffset = serial - 1; // Subtract 1 because Excel's date system includes a leap year bug
                    return new Date(excelEpoch.getTime() + daysOffset * 86400000).toISOString().slice(0, 10); // Format as YYYY-MM-DD
                };

                // Create a formatted JSON object based on headers and row values
                const formattedJson = rows.map((row) => {
                    const obj = {};
                    headers.forEach((header, index) => {
                        // Check if the column is one of the date fields and convert it if necessary
                        if (dateFields.includes(header) && row[index] && typeof row[index] === "number") {
                            obj[header] = convertExcelDate(row[index]); // Convert date
                        } else {
                            obj[header] = row[index] !== undefined ? row[index] : null;
                        }
                    });
                    return obj;
                });

                // Resolve the promise with the formatted JSON data
                resolve(formattedJson);
            } catch (error) {
                reject(error); // Reject the promise if there's an error
            }
        };

        reader.onerror = (error) => {
            reject(error); // Reject the promise if there's a FileReader error
        };

        reader.readAsArrayBuffer(file);
    });
};

const formatToIndianCurrency = (amount) =>
    new Intl.NumberFormat("en-IN", {
        maximumSignificantDigits: 21,
        style: "decimal",
        minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
    }).format(amount);

const sortProjects = (data, codeKey) => {
    const splitCodeParts = (code) => {
        if (!code || typeof code !== "string") {
            return { projectType: "", numericPart: 0, company: "" };
        }

        // Split the code into parts based on "/"
        const parts = code.trim().split("/");

        // Treat everything before the numeric part as the project type
        const projectType = parts.slice(0, -2).join("/"); // Everything before the numeric part
        // const numericPart = parts[parts.length - 2] ? parseInt(parts[parts.length - 2], 10) : 0; // Second last part (numeric part)
        const numericPart = parts[parts.length - 2]
            ? parts[parts.length - 2].padStart(3, "0")
            : "000";
        const company = parts[parts.length - 1] || ""; // Last part as company (e.g., "CIPL", "SP")

        return { projectType, numericPart, company };
    };

    return data.sort((a, b) => {
        const aParts = splitCodeParts(a[codeKey]);
        const bParts = splitCodeParts(b[codeKey]);

        // Compare project type (everything before the numeric part)
        if (aParts.projectType !== bParts.projectType) {
            return aParts.projectType.localeCompare(bParts.projectType);
        }

        // Compare company name (e.g., "CIPL" vs "SP")
        if (aParts.company !== bParts.company) {
            return aParts.company.localeCompare(bParts.company);
        }

        // Compare numeric part (e.g., 1 vs 2)
        // return aParts.numericPart - bParts.numericPart;
        // return Number(aParts.numericPart) - Number(bParts.numericPart);
        // Compare numeric part with validation for NaN
        const numA = Number(aParts.numericPart);
        const numB = Number(bParts.numericPart);

        if (!isNaN(numA) && !isNaN(numB)) {
            return numA - numB; // Compare numerically if both are valid numbers
        } else {
            // If not valid numbers, fallback to localeCompare
            // return aParts.numericPart.toString().localeCompare(bParts.numericPart.toString());
            return aParts.numericPart.localeCompare(bParts.numericPart); // Compare as strings if not valid
        }
    });
};

const customSortProjects = (data, codeKey) => {
    const splitCodeParts = (code) => {
        if (!code || typeof code !== "string") {
            return { firstPart: "", numericPart: 0, alphaPart: "" };
        }

        // Split the code into two parts: before and after the last "/"
        const parts = code.trim().split("/");
        const firstPart = parts.slice(0, -1).join("/"); // Everything before the last "/"
        const lastPart = parts.pop(); // The last part after the "/"

        // Match numeric and alphabetic parts from the last part (e.g., "001CM" -> 001 and CM)
        const match = lastPart.match(/^(\d+)?([A-Za-z]+)$/); // Adjust regex to prioritize alphabetic part
        if (match) {
            return {
                firstPart, // Part before the last "/"
                numericPart: match[1] ? parseInt(match[1], 10) : 0, // Numeric part (if present)
                alphaPart: match[2] || "", // Alphabetic part
            };
        }

        return { firstPart, numericPart: 0, alphaPart: "" };
    };

    return data.sort((a, b) => {
        const aParts = splitCodeParts(a[codeKey]);
        const bParts = splitCodeParts(b[codeKey]);

        // Compare the first part (e.g., "AE/IE" vs "OM")
        if (aParts.firstPart !== bParts.firstPart) {
            return aParts.firstPart.localeCompare(bParts.firstPart);
        }

        // If the first parts are the same, compare the alphabetic part (e.g., "CM" vs "SP")
        if (aParts.alphaPart !== bParts.alphaPart) {
            return aParts.alphaPart.localeCompare(bParts.alphaPart);
        }

        // If alphabetic parts are the same, compare the numeric part (e.g., "001" vs "002")
        return aParts.numericPart - bParts.numericPart;
    });
};

const ascSortByKey = (data, key) => {
    const regex = /([A-Za-z]+)|(\d+)|(\W+)/g;

    // Function to access a deeply nested object property using dot notation
    const getNestedValue = (obj, key) => {
        return key.split(".").reduce((o, i) => (o ? o[i] : undefined), obj);
    };

    // Custom sort function for object comparison
    const sortFunction = (a, b) => {
        // Get the values to be compared from the key (handle nested properties)
        const aValue = getNestedValue(a, key);
        const bValue = getNestedValue(b, key);

        if (!aValue || !bValue) return 0; // Return 0 if either value is undefined

        // Split the strings into alphabetic, numeric, and special character parts
        const aParts = aValue.match(regex);
        const bParts = bValue.match(regex);

        for (let i = 0; i < Math.min(aParts.length, bParts.length); i++) {
            const aPart = aParts[i];
            const bPart = bParts[i];

            // Check if both parts are numeric
            if (!isNaN(aPart) && !isNaN(bPart)) {
                const numA = Number(aPart);
                const numB = Number(bPart);
                if (numA !== numB) {
                    return numA - numB; // Compare numerically
                }
            } else if (aPart !== bPart) {
                return aPart.localeCompare(bPart); // Compare alphabetically or by special characters
            }
        }

        // If we reach here, the longer string is considered greater
        return aParts.length - bParts.length;
    };

    // Sort the data using the custom sort function
    return data.sort(sortFunction);
};

const customSortByKey = (data, key) => {
    const regex = /([A-Za-z]+)|(\d+)|(\W+)/g;

    // Function to access a deeply nested object property using dot notation
    const getNestedValue = (obj, key) => {
        return key.split('.').reduce((o, i) => (o ? o[i] : undefined), obj);
    };

    // Custom sort function for object comparison
    const sortFunction = (a, b) => {
        // Get the values to be compared from the key (handle nested properties)
        const aValue = getNestedValue(a, key);
        const bValue = getNestedValue(b, key);

        if (!aValue || !bValue) return 0; // Return 0 if either value is undefined

        // Split the strings into alphabetic, numeric, and special character parts
        const aParts = aValue.match(regex);
        const bParts = bValue.match(regex);

        for (let i = 0; i < Math.min(aParts.length, bParts.length); i++) {
            const aPart = aParts[i];
            const bPart = bParts[i];

            // Check if both parts are numeric
            if (!isNaN(aPart) && !isNaN(bPart)) {
                const numA = Number(aPart);
                const numB = Number(bPart);
                if (numA !== numB) {
                    return numA - numB; // Compare numerically
                }
            } else if (aPart !== bPart) {
                return aPart.localeCompare(bPart); // Compare alphabetically or by special characters
            }
        }

        // If we reach here, the longer string is considered greater
        return aParts.length - bParts.length;
    };

    // Sort the data using the custom sort function
    return data.sort(sortFunction);
};

const downloadAsExcel = (
    tableRef,
    sheetName = "Sheet1",
    fileName = "download.xls"
) => {
    if (!tableRef || !tableRef.current) {
        console.error("Invalid table reference");
        return;
    }

    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.aoa_to_sheet([]);

    let rowIndex = 0;

    for (let row of tableRef.current.rows) {
        const rowData = [];
        for (let cell of row.cells) {
            const nestedTable = cell.querySelector("table");

            if (nestedTable) {
                // Format nested table data into a single cell
                let nestedData = "";
                for (let nestedRow of nestedTable.rows) {
                    for (let nestedCell of nestedRow.cells) {
                        nestedData += nestedCell.innerText + "\n"; // Append with line breaks
                    }
                }
                rowData.push(nestedData.trim()); // Add formatted nested data into the cell
            } else {
                rowData.push(cell.innerText); // Normal cells
            }
        }

        if (rowData.length > 0) {
            XLSX.utils.sheet_add_aoa(worksheet, [rowData], { origin: rowIndex });
            rowIndex++;
        }
    }

    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

    const workbookBinary = XLSX.write(workbook, {
        bookType: "xls",
        type: "binary",
    });
    const s2ab = (str) => {
        const buf = new ArrayBuffer(str.length);
        const view = new Uint8Array(buf);
        for (let i = 0; i < str.length; i++) view[i] = str.charCodeAt(i) & 0xff;
        return buf;
    };

    const buffer = s2ab(workbookBinary);
    const blob = new Blob([buffer], { type: "application/vnd.ms-excel" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
};

const inputMaxLimit = (name, value, maxValue) => {
    const numericValue = value.trim() ? parseFloat(value) : 0;

    if (numericValue <= maxValue) {
        return { success: true, error: "" };
    } else {
        return {
            success: false,
            error: `Value must be less than or equal to ${maxValue}`,
        };
    }
};

const inputMinLimit = (name, value, minValue) => {
    const numericValue = value.trim() ? parseFloat(value) : 0;

    if (numericValue >= minValue) {
        return { success: true, error: "" };
    } else {
        return {
            success: false,
            error: `Value must be more than or equal to ${minValue}`,
        };
    }
};

const getFileNameFromLink = (url) => {
    try {
        const ImgFileUrl = "https://cipl-aimantra.s3.amazonaws.com/" || "https://cipl-aimantra.s3.ap-south-1.amazonaws.com/";
        // const ImgFileUrl = "https://cipl-aimantra.s3.amazonaws.com/" || "https://cipl-aimantra.s3.ap-south-1.amazonaws.com/";

        if (url.startsWith(ImgFileUrl)) {
            const pathAfterBase = url.slice(ImgFileUrl.length);

            const fileName = pathAfterBase.split('/').slice(1).join('/').split('?')[0];

            return fileName;
        }

        return url;
    } catch (error) {
        console.error("Error extracting file name:", error);
        return "";
    }
};

const ViewFile = ({ doc, filename, filesrc }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
    };

    const isImage = (url) => {
        return /\.(jpg|jpeg|png|gif|bmp|webp)(\?.*)?$/.test(url);
    };
    return (
        <>
            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <button
                title={"View File"}
                style={{ cursor: "pointer" }}
                onClick={handleShow}
            >
                <Attachment />
            </button>
            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>{filename}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="flex-row justify-center">
                            {/* <img className="bill-img" src={i.bill} alt={`Bill Image of ${i.item_name}`} /> */}
                            {isImage(filesrc) ? (
                                <img
                                    className="bill-img"
                                    src={`${IMAGE_URL}${filesrc}`}
                                    alt={`File/ of ${filename}`}
                                />
                            ) : (
                                <a
                                    href={`${IMAGE_URL}${filesrc}`}
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <DocumentIcon />
                                    Open Document
                                </a>
                            )}
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

const CustomModel = ({ i, usedFor, title }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => {
        setShow(false);
    }
    const handleShow = () => {
        setShow(true);
    }
    return (
        <>
            <button
                onClick={handleShow}
                className=""
                style={{
                    // marginBottom: "10px",
                    height: usedFor === "table" ? "20px" : usedFor === "nestedTable" ? "0px" : "30px",
                    width: usedFor === "table" ? "3vw" : usedFor === "nestedTable" ? "0vw" : "5vw",
                    borderRadius: usedFor === "table" ? "6px" : "10px",
                    fontSize: usedFor === "nestedTable" ? "12px" : "14px"

                }}
            >
                <span className="view-text" >View</span>
            </button>
            <Modal show={show} onHide={handleClose} dialogClassName="custom-modal">
                <Modal.Header closeButton>
                    <Modal.Title>
                        View {title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>{i}</p>
                </Modal.Body>
            </Modal>
        </>
    )
}


function calculateNextDate(startDate, daysToAdd) {
    const date = new Date(startDate);
    date.setDate(date.getDate() + parseInt(daysToAdd));
    return date.toISOString().split('T')[0]; // Returns in 'yyyy-mm-dd' format
}

function subtractDaysFromDate(startDate, daysToSubtract) {
    if (!startDate || isNaN(daysToSubtract)) return null;

    const date = new Date(startDate);
    if (isNaN(date)) return null;

    date.setDate(date.getDate() - parseInt(daysToSubtract));


    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
}






const ViewOtherFile = ({ doc, filename, filesrc }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
    }

    const isImage = (url) => {
        return /\.(jpg|jpeg|png|gif|bmp|webp)(\?.*)?$/.test(url);
    }
    return (
        <>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            <button title={"View File"} style={{ cursor: "pointer" }} onClick={handleShow}>
                {/* <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                    viewBox="0 0 16.933 16.933"
                    id="bill">
                    <path
                        d="M1.854 0C.819 0 0 .83 0 1.852c-.002 4.94.002 9.878.002 14.816 0 .221.256.345.429.207l1.488-1.19 1.488 1.19a.265.265 0 0 0 .33 0l1.488-1.19 1.49 1.19a.265.265 0 0 0 .33 0l1.489-1.19 1.488 1.19a.265.265 0 0 0 .33 0l1.487-1.19 1.488 1.19c.174.139.43.015.43-.207l.002-8.733h2.91a.26.26 0 0 0 .263-.263V1.854A1.85 1.85 0 0 0 15.083 0Zm0 .53h11.932c-.35.337-.556.8-.556 1.324l-.002 14.265-1.222-.98a.265.265 0 0 0-.33 0l-1.49 1.191-1.488-1.191a.264.264 0 0 0-.33 0L6.878 16.33 5.391 15.14a.265.265 0 0 0-.33 0L3.575 16.33 2.085 15.14a.264.264 0 0 0-.33 0l-1.224.98L.53 1.852c0-.77.634-1.322 1.324-1.322zm13.228 0c.73 0 1.324.586 1.324 1.324v5.554H13.76V1.854c0-.738.592-1.324 1.322-1.324zM3.707 3.439c-.133 0-.265.089-.265.266v.287c-.599.116-1.058.63-1.058 1.252 0 .42.217.672.48.799.264.127.552.147.816.174.265.027.506.06.639.125.133.064.181.15.181.32 0 .406-.34.743-.782.746-.384-.014-.658-.23-.784-.623-.106-.339-.614-.175-.503.162.152.475.48.844 1.011.96v.294c0 .354.53.354.53 0v-.282c.598-.116 1.058-.635 1.058-1.257 0-.388-.18-.654-.48-.799-.264-.126-.552-.146-.817-.173-.264-.028-.502-.056-.639-.126-.122-.062-.181-.142-.181-.32 0-.41.34-.742.783-.745.421.016.666.26.783.622.107.339.615.175.504-.162-.152-.474-.5-.857-1.012-.959v-.295c0-.177-.132-.266-.264-.266zm2.645.265c-.355 0-.355.527 0 .53h4.763c.353 0 .353-.53 0-.53zm0 1.852c-.355 0-.355.53 0 .53h4.763c.352 0 .353-.53 0-.53zm0 1.852c-.355 0-.355.527 0 .527h4.763c.352 0 .352-.527 0-.527zM2.649 9.26c-.356 0-.356.537 0 .529h8.466c.352 0 .352-.53 0-.53zm0 1.852c-.356 0-.356.53 0 .53h8.466c.352 0 .352-.53 0-.53zm0 1.852c-.356 0-.356.529 0 .53h8.466c.352 0 .352-.53 0-.53z"
                        fill="#2576BC"
                    >
                    </path>
                </svg> */}
                <Eye />
            </button>
            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Header closeButton>
                    <Modal.Title>{filename}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <h1 className="task-Tab-heading align-center  font-weight500  font-size-heading"><Modal.Title> File :</Modal.Title> </h1>
                        <h6 className="text-center">
                            {getFileNameFromLink(filesrc)}
                        </h6>
                        <br />
                        <div className="flex-row justify-center">
                            {/* <img className="bill-img" src={i.bill} alt={`Bill Image of ${i.item_name}`} /> */}
                            {isImage(filesrc) ? (
                                <img className="bill-img" src={`${IMAGE_URL}${filesrc}`} alt={`File/ Image of ${filename}`} />
                            ) : (
                                <a href={filesrc} target="_blank" rel="noreferrer">
                                    <PDFIcon />
                                    Open Document
                                </a>
                            )}
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}

const ViewReciept = ({ doc, filename, filesrc }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
    };

    const isImage = (url) => {
        return /\.(jpg|jpeg|png|gif|bmp|webp)(\?.*)?$/.test(url);
    };
    return (
        <>
            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <button
                title={"View File"}
                style={{ cursor: "pointer" }}
                onClick={handleShow}
            >
                <Attachment />
            </button>
            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>For : {filename}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="flex-row justify-center">
                            {/* <img className="bill-img" src={i.bill} alt={`Bill Image of ${i.item_name}`} /> */}
                            {isImage(filesrc) ? (
                                <img
                                    className="bill-img"
                                    src={`${IMAGE_URL}${filesrc}`}
                                    alt={`File/ Image of ${filename}`}
                                />
                            ) : (
                                <a
                                    href={`${IMAGE_URL}${filesrc}`}
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <DocumentIcon />
                                    Open File
                                </a>
                            )}
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};


const ViewDynamicApprovalDates = ({ dynamic_approval }) => {
    if (!Array.isArray(dynamic_approval)) {
        return <td className="table-body">No Status Available</td>;
    }
    return (
        <td title="Approval Dates" className="table-body">
            {dynamic_approval.map((i, index) => (
                <div request-status={i.approval_status} className="request-status " key={index}>
                    {i.approval_status === "approved" ?
                        <div
                        // request-status={i.approval_status}
                        // className="request-status "
                        >
                            {i.employee ? (i.role ? `${i.employee?.name}(${i.role?.role_name})` : `${i.employee?.name}`) : i.role?.role_name} Approved
                            {i.updated_at ? <><br />At: {formatDateTime(i.updated_at).date}</> : ''}
                        </div>
                        // </div>
                        : "-"}
                </div>
            ))}
        </td>

    );
};

const ViewDynamicApprovalStatus = ({ dynamic_approval, Table }) => {
    if (!Array.isArray(dynamic_approval)) {
        return <td className="table-body">No Status Available</td>;
    }

    const getLabel = (i) =>
        i.employee ? (i.role ? `${i.employee?.name} (${i.role?.role_name})` : i.employee?.name) : i.role?.role_name;

    return (
        <>
            <style>{`
                .das-pill {
                    display: inline-flex;
                    align-items: center;
                    gap: 5px;
                    padding: 4px 10px;
                    border-radius: 999px;
                    font-size: 11.5px;
                    font-weight: 600;
                    white-space: nowrap;
                    margin: 2px 0;
                }
                .das-pill.pending {
                    background: #fef9c3;
                    color: #854d0e;
                }
                .das-pill.rejected {
                    background: #fee2e2;
                    color: #b91c1c;
                }
                .das-pill.approved {
                    background: #dcfce7;
                    color: #15803d;
                }
                .das-stack {
                    display: flex;
                    flex-direction: column;
                    align-items: start;
                    gap: 3px;
                }
            `}</style>
            <td title="Status" className="table-body">
                <div className="das-stack">
                    {dynamic_approval.map((i, index) => {
                        const status = i.approval_status;
                        const label = getLabel(i);
                        return (
                            <span
                                key={index}
                                request-status={status}
                                className={`das-pill ${status === "pending" ? "pending" : status === "rejected" ? "rejected" : "approved"}`}
                            >
                                {status === "pending" ? (
                                    <>
                                        <Clock size={11} /> Pending: {label}
                                    </>
                                ) : status === "rejected" ? (
                                    <>
                                        <X size={11} /> {label}
                                    </>
                                ) : (
                                    <>
                                        <Check size={11} /> {label}
                                    </>
                                )}
                            </span>
                        );
                    })}
                </div>
            </td>
        </>
    );
};
const ViewDynamicboqStatus = ({ dynamic_approval, Table }) => {
    if (!Array.isArray(dynamic_approval)) {
        return <td className="table-body">No Status Available</td>;
    }


    const getLabel = (i) => {
        return i.employee ? i.employee_details?.name : (i.role_name || i.role_details?.role_name);
    };
    return (
        <>
            <style>{`
                .das-pill {
                    display: inline-flex;
                    align-items: center;
                    gap: 5px;
                    padding: 4px 10px;
                    border-radius: 999px;
                    font-size: 11.5px;
                    font-weight: 600;
                    white-space: nowrap;
                    margin: 2px 0;
                }
                .das-pill.pending {
                    background: #fef9c3;
                    color: #854d0e;
                }
                .das-pill.rejected {
                    background: #fee2e2;
                    color: #b91c1c;
                }
                .das-pill.approved {
                    background: #dcfce7;
                    color: #15803d;
                }
                .das-stack {
                    display: flex;
                    flex-direction: column;
                    align-items: start;
                    gap: 3px;
                }
            `}</style>
            <td title="Status" className="table-body">
                <div className="das-stack">
                    {dynamic_approval.map((i, index) => {
                        const status = i.approval_status;
                        const label = getLabel(i);
                        return (
                            <span
                                key={index}
                                request-status={status}
                                className={`das-pill ${status === "approved" ? "approved" : status === "rejected" ? "rejected" : "pending"}`}
                            >
                                {status === "approved" ? (
                                    <>
                                        <Check size={11} /> Approved: {label}
                                    </>
                                ) : status === "rejected" ? (
                                    <>
                                        <X size={11} /> Rejected: {label}
                                    </>
                                ) : (
                                    <>
                                        <Clock size={11} /> Pending: {label}
                                    </>
                                )}
                            </span>
                        );
                    })}
                </div>
            </td>
        </>
    );
};

const ViewDynamicApprovalRemarks = ({ dynamic_approval }) => {
    if (!Array.isArray(dynamic_approval)) {
        return <td className="table-body">No Status Available</td>;
    }

    const getLabel = (i) =>
        i.employee ? (i.role ? `${i.employee?.name} (${i.role?.role_name})` : i.employee?.name) : i.role?.role_name;

    const visibleRemarks = dynamic_approval.filter((i) => i.approval_status !== "pending");

    return (
        <>
            <style>{`
                .dar-note {
                    display: flex;
                    flex-direction: column;
                    gap: 2px;
                    padding: 6px 10px;
                    border-radius: 10px;
                    font-size: 11.5px;
                    margin: 3px 0;
                    text-align: left;
                }
                .dar-note.rejected {
                    background: #fee2e2;
                    color: #b91c1c;
                }
                .dar-note.approved {
                    background: #f0fdf4;
                    color: #166534;
                }
                .dar-note-name {
                    font-weight: 700;
                }
                .dar-note-meta {
                    font-size: 10.5px;
                    color: inherit;
                    opacity: 0.8;
                }
                .dar-empty {
                    color: #94a3b8;
                    font-size: 12px;
                }
            `}</style>
            <td title="Remarks" className="table-body">
                {visibleRemarks.length === 0 ? (
                    <span className="dar-empty">-</span>
                ) : (
                    visibleRemarks.map((i, index) => {
                        const label = getLabel(i);
                        const isRejected = i.approval_status === "rejected";
                        return (
                            <div
                                key={index}
                                request-status={i.approval_status}
                                className={`dar-note ${isRejected ? "rejected" : "approved"}`}
                            >
                                {isRejected ? (
                                    <>
                                        <span className="dar-note-name">{label}</span>
                                        <span>Reject Reason: {i.remarks}</span>
                                    </>
                                ) : (
                                    <>
                                        <span className="dar-note-name">
                                            {label}{i.updated_by ? ` (${i?.updated_by?.name})` : ''}
                                        </span>
                                        <span className="dar-note-meta">
                                            Checked{i.updated_at ? ` at ${formatDateTime(i.updated_at).date}` : ''}
                                        </span>
                                    </>
                                )}
                            </div>
                        );
                    })
                )}
            </td>
        </>
    );
};


const ViewRequestStatusRemarks = ({ dynamic_approval }) => {
    if (!Array.isArray(dynamic_approval)) {
        return <td className="table-body">No status available</td>;
    }

    return (
        <td className="table-body">
            {dynamic_approval.map((i, index) => (

                <div request-status={i.approval_status} className="request-status" key={index}>
                    {i.approval_status === "pending"
                        ? `Pending For ${i.employee ? (i.role ? `${i.employee?.name}(${i.role?.role_name})` : `${i.employee?.name}`) : i.role?.role_name} Approval ⌛`
                        : i.approval_status === "rejected"
                            ? `${i.employee ? (i.role ? `${i.employee?.name}(${i.role?.role_name})` : `${i.employee?.name}`) : i.role?.role_name} ✖`
                            : `${i.employee ? (i.role ? `${i.employee?.name}(${i.role?.role_name})` : `${i.employee?.name}`) : i.role?.role_name} ✔`}
                </div>
            ))}
        </td>

    );
};

const ViewRequestStatus = ({ i, approval_stages_data }) => {
    console.log(i, 'stauts expense', approval_stages_data != null && approval_stages_data != undefined && approval_stages_data?.checker)
    return (
        <>
            <td className="table-body">
                {approval_stages_data != null && approval_stages_data != undefined && approval_stages_data.checker ? (<>
                    <span
                        request-status={i.checker_approval_status}
                        className="request-status "
                        title={i.checker_approval_status === "rejected" ? `Checker Reject Reason : ${i.checker_rejection_reason}` : ""}
                    >
                        {/* {console.log(approval_stages_data.checker), 'checker '} */}
                        {i.checker_approval_status === "pending"
                            ? "Pending For Checker Approval ⌛"
                            : i.checker_approval_status === "rejected"
                                ? "Checker ✖, "
                                : "Checker ✔, "}
                    </span>
                    <br /></>) : (<>
                        <span

                            className="request-status ">
                            Checker Step was skipped
                        </span >
                        <br />
                    </>)}

                {approval_stages_data != null && approval_stages_data != undefined && approval_stages_data?.authority ? (<>
                    <span
                        request-status={i.authority_approval_status}
                        className="request-status "
                        title={i.authority_approval_status === "rejected" ? `Authority Reject Reason : ${i.authority_rejection_reason}` : ""}
                    >
                        {i.authority_approval_status === "pending"
                            ? "Pending For Authority Approval ⌛"
                            : i.authority_approval_status === "rejected"
                                ? "Authority ✖, "
                                : "Authority ✔, "}
                    </span>
                    <br />
                </>) : (<>
                    <span

                        className="request-status ">
                        Authority Step was skipped
                    </span >
                    <br />
                </>)}


                {approval_stages_data != null && approval_stages_data != undefined && approval_stages_data.account ? (<>
                    <span
                        request-status={i.account_status_a}
                        className="request-status "
                        title={i.account_status_a === "rejected" ? `Account Reject Reason : ${i.account1_rejection_reason}` : ""}
                    >
                        {i.authority_approval_status === "rejected" &&
                            i.admin_approval_status === "rejected" &&
                            i.account_status_a === "rejected"
                            ? "Account ✖, "
                            : i.authority_approval_status === "approved" &&
                                i.admin_approval_status === "approved" &&
                                i.account_status_a === "pending"
                                ? "Pending For Account Approval ⌛"
                                : i.authority_approval_status === "approved" &&
                                    i.admin_approval_status === "approved" &&
                                    i.account_status_a === "rejected"
                                    ? "Accounts ✖, "
                                    : i.authority_approval_status === "approved" &&
                                        i.admin_approval_status === "approved" &&
                                        i.account_status_a === "approved"
                                        ? "Accounts ✔, "
                                        : "Accounts Stage 1: " + i.account_status_a}
                    </span>
                    <br />
                </>) : (
                    <>
                        <span
                            request-status={!i.account_status_a}
                            className="request-status ">
                            Account1 Step was skipped
                        </span >
                        <br />
                    </>
                )}


                {approval_stages_data != null && approval_stages_data != undefined && approval_stages_data.admin1 ? (<>
                    <span
                        request-status={i.admin_approval_status_c1}
                        className="request-status "
                        title={i.admin_approval_status_c1 === "rejected" ? `Admin 1 Reject Reason : ${i.admin_rejection_reason_c1}` : ""}
                    >
                        {i.authority_approval_status === "rejected" &&
                            i.admin_approval_status_c1 === "rejected"
                            ? "Admin 1 ✖, "
                            : i.authority_approval_status === "approved" &&
                                i.admin_approval_status_c1 === "pending"
                                ? `Pending For Admin 1 Approval ⌛, ${approval_stages_data.admin1_emp ? approval_stages_data.admin1_emp : ""}`
                                : i.authority_approval_status === "approved" &&
                                    i.admin_approval_status_c1 === "rejected"
                                    ? "Admin 1 ✖, "
                                    : i.authority_approval_status === "approved" &&
                                        i.admin_approval_status_c1 === "approved"
                                        ? `Admin 1  ✔, ${approval_stages_data.admin1_emp ? approval_stages_data.admin1_emp : ""}`
                                        : "Admin 1 Status1: " + (i.admin_approval_status_c1 ? i.admin_approval_status_c1 : '')}
                    </span>
                    <br />
                </>) : (
                    <>
                        <span

                            className="request-status ">
                            Admin1 Step was skipped
                        </span >
                        <br />
                    </>
                )}


                {approval_stages_data != null && approval_stages_data != undefined && approval_stages_data.admin2 ? (<>
                    <span
                        request-status={i.admin_approval_status_c2}
                        className="request-status "
                        title={i.admin_approval_status_c2 === "rejected" ? `Admin 2 Reject Reason : ${i.admin_rejection_reason_c2}` : ""}
                    >
                        {i.authority_approval_status === "rejected" &&
                            i.admin_approval_status_c2 === "rejected"
                            ? "Admin 2 ✖, "
                            : i.authority_approval_status === "approved" &&
                                i.admin_approval_status_c2 === "pending"
                                ? `Pending For Admin 2 Approval ⌛, ${approval_stages_data.admin2_emp ? approval_stages_data.admin2_emp : ""}`
                                : i.authority_approval_status === "approved" &&
                                    i.admin_approval_status_c2 === "rejected"
                                    ? "Admin 2 ✖, "
                                    : i.authority_approval_status === "approved" &&
                                        i.admin_approval_status_c2 === "approved"
                                        ? `Admin 2  ✔, ${approval_stages_data.admin2_emp ? approval_stages_data.admin2_emp : ""}`
                                        : "Admin 2 Status2: " + (i.admin_approval_status_c2 ? i.admin_approval_status_c2 : '')}
                    </span>
                    <br />
                </>) : (
                    <>
                        <span

                            className="request-status ">
                            Admin2 Step was skipped
                        </span >
                        <br />
                    </>
                )}
                {approval_stages_data != null && approval_stages_data != undefined && approval_stages_data.admin3 ? (<>
                    <span
                        request-status={i.admin_approval_status_c3}
                        className="request-status "
                        title={i.admin_approval_status_c3 === "rejected" ? `Admin 3 Reject Reason : ${i.admin_rejection_reason_c3}` : ""}
                    >
                        {i.authority_approval_status === "rejected" &&
                            i.admin_approval_status_c3 === "rejected"
                            ? "Admin 3 ✖, "
                            : i.authority_approval_status === "approved" &&
                                i.admin_approval_status_c3 === "pending"
                                ? `Pending For Admin 3 Approval ⌛, ${approval_stages_data.admin3_emp ? approval_stages_data.admin3_emp : ""}`
                                : i.authority_approval_status === "approved" &&
                                    i.admin_approval_status_c3 === "rejected"
                                    ? "Admin 3 ✖, "
                                    : i.authority_approval_status === "approved" &&
                                        i.admin_approval_status_c3 === "approved"
                                        ? `Admin 3  ✔, ${approval_stages_data.admin3_emp ? approval_stages_data.admin3_emp : ""}`
                                        : "Admin 3 Status3: " + (i.admin_approval_status_c3 ? i.admin_approval_status_c3 : '')}
                    </span>
                    <br />
                </>) : (<>
                    <span

                        className="request-status ">
                        Admin3 Step was skipped
                    </span >
                    <br />
                </>)}

                {approval_stages_data != null && approval_stages_data != undefined && approval_stages_data.payment_settlement ? (<>
                    <span
                        request-status={i.account_status_b}
                        className="request-status"
                    >
                        {i.authority_approval_status === "rejected" &&
                            i.admin_approval_status === "rejected" &&
                            i.account_status_b === "rejected"
                            ? "Account ✖, "
                            : i.authority_approval_status === "approved" &&
                                i.admin_approval_status === "approved" &&
                                i.account_status_b === "pending"
                                ? "Pending For Account Approval ⌛"
                                : i.authority_approval_status === "approved" &&
                                    i.admin_approval_status === "approved" &&
                                    i.account_status_b === "rejected"
                                    ? "Accounts ✖, "
                                    : i.authority_approval_status === "approved" &&
                                        i.admin_approval_status === "approved" &&
                                        i.account_status_b === "approved"
                                        ? "Accounts ✔, "
                                        : "Accounts Stage 2: " + i.account_status_b}
                    </span>
                </>) : (
                    <>
                        <span

                            className="request-status ">
                            Account2 Step was skipped
                        </span >
                        <br />
                    </>
                )}

            </td>
        </>
    );
};

const ViewRequestStatusExpense = ({ i, approval_stages_data }) => {
    // console.log(i, 'stauts expense1')
    return (
        <>
            <td className="table-body">
                {approval_stages_data != null && approval_stages_data != undefined && approval_stages_data.checker ?
                    (<>

                        <span
                            request-status={i.expense_checker_approval_status}
                            className="request-status "
                            title={i.expense_checker_approval_status === "rejected" ? `Checker Reject Reason : ${i.checker_rejection_reason}` : ""}
                        >
                            {i.expense_checker_approval_status === "pending"
                                ? "Pending For Checker Approval ⌛"
                                : i.expense_checker_approval_status === "rejected"
                                    ? "Checker ✖, "
                                    : "Checker ✔, "}
                        </span>
                        <br />



                    </>) : (
                        <>
                            <span

                                className="request-status ">
                                Checker  Step was skipped
                            </span >
                            <br />
                        </>
                    )}

                {approval_stages_data != null && approval_stages_data != undefined && approval_stages_data.authority ? (
                    <>                  <span
                        request-status={i.authority_approval_status}
                        className="request-status "
                        title={i.authority_approval_status === "rejected" ? `Authority Reject Reason : ${i.authority_rejection_reason}` : ""}
                    >
                        {i.authority_approval_status === "pending"
                            ? "Pending For Authority Approval ⌛"
                            : i.authority_approval_status === "rejected"
                                ? "Authority ✖, "
                                : "Authority ✔, "}
                    </span>
                        <br />
                    </>
                ) : (<>

                    <span

                        className="request-status ">
                        Authority  Step was skipped
                    </span >
                    <br />
                </>)}

                {approval_stages_data != null && approval_stages_data != undefined && approval_stages_data.account ? (<>
                    <span
                        request-status={i.account_status_a}
                        className="request-status "
                        title={i.account_status_a === "rejected" ? `Account Reject Reason : ${i.account1_rejection_reason}` : ""}
                    >
                        {i.authority_approval_status === "rejected" &&
                            i.expense_admin_approval_status === "rejected" &&
                            i.account_status_a === "rejected"
                            ? "Account ✖, "
                            : i.authority_approval_status === "approved" &&
                                i.expense_admin_approval_status === "approved" &&
                                i.account_status_a === "pending"
                                ? "Pending For Account Approval ⌛"
                                : i.authority_approval_status === "approved" &&
                                    i.expense_admin_approval_status === "approved" &&
                                    i.account_status_a === "rejected"
                                    ? "Accounts ✖, "
                                    : i.authority_approval_status === "approved" &&
                                        i.expense_admin_approval_status === "approved" &&
                                        i.account_status_a === "approved"
                                        ? "Accounts ✔, "
                                        : "Accounts Stage 1: " + i.account_status_a}
                    </span>
                    <br />

                </>) :
                    (
                        <>

                            <span

                                className="request-status ">
                                Account1  Step was skipped
                            </span >
                            <br />
                        </>

                    )
                }


                {approval_stages_data != null && approval_stages_data != undefined && approval_stages_data.admin1 ? (<>

                    <span
                        request-status={i.expense_admin_approval_status}
                        className="request-status "
                        title={i.expense_admin_approval_status === "rejected" ? `Admin 1 Reject Reason : ${i.admin_rejection_reason_c1}` : ""}
                    >
                        {i.authority_approval_status === "rejected" &&
                            i.expense_admin_approval_status === "rejected"
                            ? "Admin 1 ✖, "
                            : i.authority_approval_status === "approved" &&
                                i.expense_admin_approval_status === "pending"
                                ? "Pending For Admin 1 Approval ⌛,"
                                : i.authority_approval_status === "approved" &&
                                    i.expense_admin_approval_status === "rejected"
                                    ? "Admin 1 ✖, "
                                    : i.authority_approval_status === "approved" &&
                                        i.expense_admin_approval_status === "approved"
                                        ? "Admin 1 ✔, "
                                        : "Admin 1 Status1: " + (i.expense_admin_approval_status ? i.expense_admin_approval_status : '')}
                    </span>
                    <br />
                </>) :
                    (
                        <>
                            <span

                                className="request-status ">
                                Admin1  Step was skipped
                            </span >
                            <br />
                        </>
                    )
                }


                {approval_stages_data != null && approval_stages_data != undefined && approval_stages_data.admin2 ? (<>
                    <span
                        request-status={i.admin_approval_status_c2}
                        className="request-status "
                        title={i.admin_approval_status_c2 === "rejected" ? `Admin 2 Reject Reason : ${i.admin_rejection_reason_c2}` : ""}
                    >
                        {i.authority_approval_status === "rejected" &&
                            i.admin_approval_status_c2 === "rejected"
                            ? "Admin 2 ✖, "
                            : i.authority_approval_status === "approved" &&
                                i.admin_approval_status_c2 === "pending"
                                ? "Pending For Admin 2 Approval ⌛,"
                                : i.authority_approval_status === "approved" &&
                                    i.admin_approval_status_c2 === "rejected"
                                    ? "Admin 2 ✖, "
                                    : i.authority_approval_status === "approved" &&
                                        i.admin_approval_status_c2 === "approved"
                                        ? `Admin 2 ✔,${approval_stages_data.admin2_emp ? approval_stages_data.admin2_emp : ""}`
                                        : "Admin 2 Status2: " + (i.admin_approval_status_c2 ? i.admin_approval_status_c2 : '')}
                    </span>
                    <br />
                </>) : (
                    <>
                        <span

                            className="request-status ">
                            Admin2 Step was skipped
                        </span >
                        <br />
                    </>
                )
                }

                {approval_stages_data != null && approval_stages_data != undefined && approval_stages_data.admin3 ? (<>
                    <span
                        request-status={i.admin_approval_status_c3}
                        className="request-status "
                        title={i.admin_approval_status_c3 === "rejected" ? `Admin 2 Reject Reason : ${i.admin_rejection_reason_c3}` : ""}
                    >
                        {i.authority_approval_status === "rejected" &&
                            i.admin_approval_status_c3 === "rejected"
                            ? "Admin 3 ✖, "
                            : i.authority_approval_status === "approved" &&
                                i.admin_approval_status_c3 === "pending"
                                ? `Pending For Admin 3 Approval ⌛,${approval_stages_data.admin3_emp ? approval_stages_data.admin3_emp : ""}`
                                : i.authority_approval_status === "approved" &&
                                    i.admin_approval_status_c3 === "rejected"
                                    ? "Admin 3 ✖, "
                                    : i.authority_approval_status === "approved" &&
                                        i.admin_approval_status_c3 === "approved"
                                        ? `Admin 3 ✔,${approval_stages_data.admin3_emp ? approval_stages_data.admin3_emp : ""}`
                                        : "Admin 3 Status3: " + (i.admin_approval_status_c3 ? i.admin_approval_status_c3 : '')}
                    </span>
                    <br />
                </>) : (<>
                    <span

                        className="request-status ">
                        Admin3 Step was skipped
                    </span >
                    <br />
                </>)}


                {approval_stages_data != null && approval_stages_data != undefined && approval_stages_data.payment_settlement ? (<>
                    <span
                        request-status={i.account_status_b}
                        className="request-status"
                    >
                        {i.authority_approval_status === "rejected" &&
                            i.expense_admin_approval_status === "rejected" &&
                            i.account_status_b === "rejected"
                            ? "Account ✖, "
                            : i.authority_approval_status === "approved" &&
                                i.expense_admin_approval_status === "approved" &&
                                i.account_status_b === "pending"
                                ? "Pending For Account Approval ⌛"
                                : i.authority_approval_status === "approved" &&
                                    i.expense_admin_approval_status === "approved" &&
                                    i.account_status_b === "rejected"
                                    ? "Accounts ✖, "
                                    : i.authority_approval_status === "approved" &&
                                        i.expense_admin_approval_status === "approved" &&
                                        i.account_status_b === "approved"
                                        ? "Accounts ✔, "
                                        : "Accounts Stage 2: " + i.account_status_b}
                    </span>
                </>) : (
                    <>
                        <span

                            className="request-status ">
                            Account2  Step was skipped
                        </span >
                        <br />
                    </>
                )}

            </td>
        </>
    );
};

const ViewRequestStatusImprest = ({ i, approval_stages_data }) => {
    // console.log(i, 'stauts')
    return (
        <>
            <td className="table-body">
                {approval_stages_data != null && approval_stages_data != undefined && approval_stages_data.checker ? (<>

                    <span
                        request-status={i.checker_approval_status}
                        className="request-status "
                        title={i.checker_approval_status === "rejected" ? `Checker Reject Reason : ${i.checker_rejection_reason}` : ""}
                    >
                        {i.checker_approval_status === "pending"
                            ? "Pending For Checker Approval ⌛"
                            : i.checker_approval_status === "rejected"
                                ? "Checker ✖, "
                                : "Checker ✔, "}
                    </span>
                    <br />
                </>) : (
                    <>
                        <span

                            className="request-status ">
                            Checker  Step was skipped
                        </span >
                        <br />
                    </>
                )}

                {approval_stages_data != null && approval_stages_data != undefined && approval_stages_data.authority ? (<>    <span
                    request-status={i.authority_approval_status}
                    className="request-status "
                    title={i.authority_approval_status === "rejected" ? `Authority Reject Reason : ${i.authority_rejection_reason}` : ""}
                >
                    {i.authority_approval_status === "pending"
                        ? "Pending For Authority Approval ⌛"
                        : i.authority_approval_status === "rejected"
                            ? "Authority ✖, "
                            : "Authority ✔, "}
                </span>
                    <br /> </>) : (
                    <>
                        <span className="request-status ">
                            Authority  Step was skipped
                        </span >
                        <br />
                    </>
                )}

                {approval_stages_data != null && approval_stages_data != undefined && approval_stages_data.account ? (<>
                    <span
                        request-status={i.account_approval_status
                        }
                        className="request-status "
                        title={i.account_approval_status
                            === "rejected" ? `Account Reject Reason : ${i.account1_rejection_reason}` : ""}
                    >
                        {i.authority_approval_status === "rejected" &&
                            i.admin_approval_status === "rejected" &&
                            i.account_approval_status
                            === "rejected"
                            ? "Account ✖, "
                            : i.authority_approval_status === "approved" &&
                                i.admin_approval_status === "approved" &&
                                i.account_approval_status
                                === "pending"
                                ? "Pending For Account Approval ⌛"
                                : i.authority_approval_status === "approved" &&
                                    i.admin_approval_status === "approved" &&
                                    i.account_approval_status
                                    === "rejected"
                                    ? "Accounts ✖, "
                                    : i.authority_approval_status === "approved" &&
                                        i.admin_approval_status === "approved" &&
                                        i.account_approval_status
                                        === "approved"
                                        ? "Accounts ✔, "
                                        : "Accounts Stage : " + i.account_approval_status
                        }
                    </span>
                    <br />
                </>) : (
                    <>
                        <span className="request-status ">
                            Account1  Step was skipped
                        </span >
                        <br />
                    </>
                )}


                {approval_stages_data != null && approval_stages_data != undefined && approval_stages_data.admin1 ? (<>
                    <span
                        request-status={i.
                            admin_approval_status
                        }
                        className="request-status "
                        title={i.
                            admin_approval_status
                            === "rejected" ? `Admin 1 Reject Reason : ${i.admin_rejection_reason_c1}` : ""}
                    >
                        {i.authority_approval_status === "rejected" &&
                            i.
                                admin_approval_status
                            === "rejected"
                            ? "Admin 1 ✖, "
                            : i.authority_approval_status === "approved" &&
                                i.
                                    admin_approval_status
                                === "pending"
                                ? `Pending For Admin 1 Approval ⌛, ${approval_stages_data.admin1_emp}`
                                : i.authority_approval_status === "approved" &&
                                    i.
                                        admin_approval_status
                                    === "rejected"
                                    ? "Admin 1 ✖, "
                                    : i.authority_approval_status === "approved" &&
                                        i.
                                            admin_approval_status
                                        === "approved"
                                        ? "Admin 1 ✔, "
                                        : "Admin 1 Status1: " + (i.
                                            admin_approval_status
                                            ? i.
                                                admin_approval_status
                                            : '')}
                    </span>
                    <br />
                </>) : (
                    <>
                        <span className="request-status ">
                            Admin1  Step was skipped
                        </span >
                        <br />
                    </>
                )}


                {approval_stages_data != null && approval_stages_data != undefined && approval_stages_data.admin2 ? (<>
                    <span
                        request-status={i.admin_approval_status_c2}
                        className="request-status "
                        title={i.admin_approval_status_c2 === "rejected" ? `Admin 2 Reject Reason : ${i.admin_rejection_reason_c2}` : ""}
                    >
                        {i.authority_approval_status === "rejected" &&
                            i.admin_approval_status_c2 === "rejected"
                            ? "Admin 2 ✖, "
                            : i.authority_approval_status === "approved" &&
                                i.admin_approval_status_c2 === "pending"
                                ? `Pending For Admin 2 Approval ⌛,${approval_stages_data.admin2_emp ? approval_stages_data.admin2_emp : ""}`
                                : i.authority_approval_status === "approved" &&
                                    i.admin_approval_status_c2 === "rejected"
                                    ? "Admin 2 ✖, "
                                    : i.authority_approval_status === "approved" &&
                                        i.admin_approval_status_c2 === "approved"
                                        ? `Admin 2 ✔, ${approval_stages_data.admin2_emp ? approval_stages_data.admin2_emp : ""}`
                                        : "Admin 2 Status2: " + (i.admin_approval_status_c2 ? i.admin_approval_status_c2 : '')}
                    </span>
                    <br />
                </>) : (
                    <>
                        <span className="request-status ">
                            Admin2  Step was skipped
                        </span >
                        <br />
                    </>
                )}

                {approval_stages_data != null && approval_stages_data != undefined && approval_stages_data.admin3 ? (<>
                    <span
                        request-status={i.admin_approval_status_c3}
                        className="request-status "
                        title={i.admin_approval_status_c3 === "rejected" ? `Admin 2 Reject Reason : ${i.admin_rejection_reason_c3}` : ""}
                    >
                        {i.authority_approval_status === "rejected" &&
                            i.admin_approval_status_c3 === "rejected"
                            ? "Admin 3 ✖, "
                            : i.authority_approval_status === "approved" &&
                                i.admin_approval_status_c3 === "pending"
                                ? `Pending For Admin 3 Approval ⌛,${approval_stages_data.admin3_emp ? approval_stages_data.admin3_emp : ""}`
                                : i.authority_approval_status === "approved" &&
                                    i.admin_approval_status_c3 === "rejected"
                                    ? "Admin 3 ✖, "
                                    : i.authority_approval_status === "approved" &&
                                        i.admin_approval_status_c3 === "approved"
                                        ? `${approval_stages_data.admin3_emp ? approval_stages_data.admin3_emp : ""}`
                                        : "Admin 3 Status3: " + (i.admin_approval_status_c3 ? i.admin_approval_status_c3 : '')}
                    </span>
                    <br />
                </>) : (
                    <>
                        <span className="request-status ">
                            Admin3  Step was skipped
                        </span >
                        <br />
                    </>
                )}

                {approval_stages_data != null && approval_stages_data != undefined && approval_stages_data.payment_settlement ? (<>
                    <span
                        request-status={i.account_status_b}
                        className="request-status"
                    >
                        {i.authority_approval_status === "rejected" &&
                            i.admin_approval_status === "rejected" &&
                            i.account_status_b === "rejected"
                            ? "Account ✖, "
                            : i.authority_approval_status === "approved" &&
                                i.admin_approval_status === "approved" &&
                                i.account_status_b === "pending"
                                ? "Pending For Account Approval ⌛"
                                : i.authority_approval_status === "approved" &&
                                    i.admin_approval_status === "approved" &&
                                    i.account_status_b === "rejected"
                                    ? "Accounts ✖, "
                                    : i.authority_approval_status === "approved" &&
                                        i.admin_approval_status === "approved" &&
                                        i.account_status_b === "approved"
                                        ? "Accounts ✔, "
                                        : "Accounts Stage 2: " + i.account_status_b !== undefined && i.account_status_b}
                    </span>
                </>) : (
                    <>
                        <span className="request-status ">
                            Account2 Step was skipped
                        </span >
                        <br />
                    </>
                )}




                {/* <span
                    request-status={i.admin_approval_status_c3}
                    className="request-status "
                    title={i.admin_approval_status_c3 === "rejected" ? `Admin 3 Reject Reason : ${i.admin_rejection_reason_c3}` : ""}
                >
                    {i.authority_approval_status === "rejected" &&
                        i.admin_approval_status_c3 === "rejected"
                        ? "Admin 3 ✖, "
                        : i.authority_approval_status === "approved" &&
                            i.admin_approval_status_c3 === "pending"
                            ? "Pending For Admin 3 Approval ⌛,"
                            : i.authority_approval_status === "approved" &&
                                i.admin_approval_status_c3 === "rejected"
                                ? "Admin 3 ✖, "
                                : i.authority_approval_status === "approved" &&
                                    i.admin_approval_status_c3 === "approved"
                                    ? "Admin 3 ✔, "
                                    : "Admin 3 Status3: " + (i.admin_approval_status_c3 ? i.admin_approval_status_c3 : '')}
                </span>
                <br /> */}


            </td >
        </>
    );
};

const ViewRequestRemarks = ({ i, table, approval_stages_data }) => {
    // console.log(approval_stages_data, table, approval_stages_data != null && approval_stages_data != undefined && approval_stages_data?.checker === true)
    return (
        <>
            <td title="Remarks and Approval Dates" className="table-body">
                {approval_stages_data != null && approval_stages_data != undefined && approval_stages_data?.checker ?
                    (
                        <>
                            <span
                                request-status={i.checker_approval_status}
                                className="request-status "
                            >
                                {/* {console.log(approval_stages_data.checker, 'checker')} */}
                                {i.checker_approval_status === "pending"
                                    ? "-"
                                    : i.checker_approval_status === "rejected"
                                        ? `Checker Reject Reason : ${i.checker_rejection_reason}`
                                        : `Checker${i.checker ? `(${i?.checker_name}) ` : ''}: Checked ${i.checker_update_datetime ? `At: ${formatDateTime(i.checker_update_datetime).date}` : ''}`}
                            </span>
                            <br />

                        </>
                    )
                    : (
                        <>
                            <span

                                className="request-status ">
                                Checker  Step was skipped
                            </span >
                            <br />
                        </>
                    )}

                {/* <span
                    request-status={i.checker_approval_status}
                    className="request-status "
                >
                    {i.checker_approval_status === "pending"
                        ? "-"
                        : i.checker_approval_status === "rejected"
                            ? `Checker Reject Reason : ${i.checker_rejection_reason}`
                            : `Checker${i.checker ? `(${i?.checker_name}) ` : ''}: Checked ${i.checker_update_datetime ? `At: ${formatDateTime(i.checker_update_datetime).date}` : ''}`}
                </span>
                <br /> */}
                {/* <br /> */}

                {approval_stages_data != null && approval_stages_data != undefined && approval_stages_data.authority ? (
                    <>
                        <span
                            request-status={i.authority_approval_status}
                            className="request-status "
                        >
                            {/* {console.log(approval_stages_data.authority, 'authority', i.authority_approval_status)} */}
                            {i.authority_approval_status === "pending"
                                ? "-"
                                : i.authority_approval_status === "rejected"
                                    ? `Authority Reject Reason : ${i.authority_rejection_reason}`
                                    : `Authority${i.authority_engineer ? `(${i?.authority_engineer_name}) ` : ''}: Verified Amounts for Bills ${i.authority_update_datetime ? `At: ${formatDateTime(i.authority_update_datetime).date}` : ''}`}
                        </span>
                        <br />
                    </>
                ) : (
                    <>
                        <span

                            className="request-status ">
                            Authority  Step was skipped
                        </span >
                        <br />
                    </>
                )}

                {/* <br /> */}

                {approval_stages_data != null && approval_stages_data != undefined && approval_stages_data.account ? (<>
                    <span
                        request-status={i.account_status_a}
                        className="request-status "
                    >
                        {i.account_status_a === "pending"
                            ? "-"
                            : i.account_status_a === "rejected"
                                ? `Accounts Reject Reason : ${i.account1_rejection_reason}`
                                : `Accounts${i.account_update_by ? `(${i?.account_update_by_name}) ` : ''}: Bills Verified ${i.account_update_datetime ? `At: ${formatDateTime(i.account_update_datetime).date}` : ''}`}
                    </span>
                    <br />
                </>) : (
                    <>
                        <span

                            className="request-status ">
                            Account1  Step was skipped
                        </span >
                        <br />
                    </>
                )}

                {/* <br /> */}

                {approval_stages_data != null && approval_stages_data != undefined && approval_stages_data.admin1 ? (<>
                    <span
                        request-status={i.admin_approval_status_c1}
                        className="request-status "
                        title={i.admin_approval_status_c1 === "rejected" ? `Admin 1 Reject Reason : ${i.admin_rejection_reason_c1}` : ""}
                    >
                        {i.admin_approval_status_c1 === "pending"
                            ? "-"
                            : i.admin_approval_status_c1 === "rejected"
                                ? `Admin 1 Rejection Reason : ${i.admin_rejection_reason_c1}`
                                : `Admin 1${i.admin_update_by_c1 ? `(${i?.admin_update_by_c1_name ? i?.admin_update_by_c1_name : ""}) ` : ''}: Approved After Verification  ${i.admin_update_datetime_c1 ? `At: ${formatDateTime(i.admin_update_datetime_c1).date}` : ''}`}
                    </span>
                    <br />
                </>) : (
                    <>
                        <span

                            className="request-status ">
                            Admin1  Step was skipped
                        </span >
                        <br />
                    </>
                )}

                {approval_stages_data != null && approval_stages_data != undefined && approval_stages_data.admin2 ? (<>
                    <span
                        request-status={i.admin_approval_status_c2}
                        className="request-status "
                        title={i.admin_approval_status_c2 === "rejected" ? `Admin 2 Reject Reason : ${i.admin_rejection_reason_c2}` : ""}
                    >
                        {i.admin_approval_status_c2 === "pending"
                            ? "-"
                            : i.admin_approval_status_c2 === "rejected"
                                ? `Admin 2 Rejection Reason : ${i.admin_rejection_reason_c2}`
                                : `Admin 2${i.admin_update_by_c2 ? `(${(i?.admin_update_by_c2_name || i.admin_update_by_name_c2) ? (i?.admin_update_by_c2_name || i.admin_update_by_name_c2) : ""}) ` : ''}: Approved After Verification  ${i.admin_update_datetime_c2 ? `At: ${formatDateTime(i.admin_update_datetime_c2).date}` : ''}`}
                    </span>
                    {/* <br />
                <span
                    request-status={i.admin_approval_status_c3}
                    className="request-status "
                    title={i.admin_approval_status_c3 === "rejected" ? `Admin 3 Reject Reason : ${i.admin_rejection_reason_c3}` : ""}
                >
                    {i.admin_approval_status_c3 === "pending"
                        ? "-"
                        : i.admin_approval_status_c3 === "rejected"
                            ? `Admin 3 Rejection Reason : ${i.admin_rejection_reason_c3}`
                            : `Admin 3${i.admin_update_by_c3 ? `(${i.admin_update_by_c3}) ` : ''}: Approved After Verification  ${i.admin_update_datetime_c3 ? `At: ${formatDateTime(i.admin_update_datetime_c3).date}` : ''}`}
                </span> */}
                    <br />
                </>) : (
                    <>
                        <span

                            className="request-status ">
                            Admin2  Step was skipped
                        </span >
                        <br />
                    </>
                )}

                {approval_stages_data != null && approval_stages_data != undefined && approval_stages_data.admin3 ? (<>
                    <span
                        request-status={i.admin_approval_status_c3}
                        className="request-status "
                        title={i.admin_approval_status_c3 === "rejected" ? `Admin 3 Reject Reason : ${i.admin_rejection_reason_c3}` : ""}
                    >
                        {i.admin_approval_status_c3 === "pending"
                            ? "-"
                            : i.admin_approval_status_c3 === "rejected"
                                ? `Admin 3 Rejection Reason : ${i.admin_rejection_reason_c3}`
                                : `Admin 3${i.admin_update_by_c3 ? `(${i?.admin_update_by_c3_name ? i?.admin_update_by_c3_name : ""}) ` : ''}: Approved After Verification  ${i.admin_update_datetime_c3 ? `At: ${formatDateTime(i.admin_update_datetime_c3).date}` : ''}`}
                    </span>
                    {/* <br />
                <span
                    request-status={i.admin_approval_status_c3}
                    className="request-status "
                    title={i.admin_approval_status_c3 === "rejected" ? `Admin 3 Reject Reason : ${i.admin_rejection_reason_c3}` : ""}
                >
                    {i.admin_approval_status_c3 === "pending"
                        ? "-"
                        : i.admin_approval_status_c3 === "rejected"
                            ? `Admin 3 Rejection Reason : ${i.admin_rejection_reason_c3}`
                            : `Admin 3${i.admin_update_by_c3 ? `(${i.admin_update_by_c3}) ` : ''}: Approved After Verification  ${i.admin_update_datetime_c3 ? `At: ${formatDateTime(i.admin_update_datetime_c3).date}` : ''}`}
                </span> */}
                    <br />
                </>) : (
                    <>
                        <span

                            className="request-status ">
                            Admin3  Step was skipped
                        </span >
                        <br />
                    </>
                )}
                {approval_stages_data != null && approval_stages_data != undefined && approval_stages_data.payment_settlement ? (<>
                    <span
                        request-status={i.account_status_b}
                        className="request-status "
                        style={{ cursor: "help" }}
                        title={`Transaction/Cheque No.:\n${i.account_status_b !== "pending" ? i.settlement_transaction_id : null}`}
                    >

                        {i.account_status_b === "pending" ? (
                            "-"
                        ) : i.account_status_b === "rejected" ? (
                            `Final Rejection Reason: ${i.account2_rejection_reason}`
                        ) : (
                            <>
                                {`Final1${i.final_update_by ? ` (${i.final_update_by_name})` : ''}: Approved And Settled `}
                                {i.final_update_datetime ? `At: ${formatDateTime(i.final_update_datetime).date} ` : ''}
                                {i.settlement_bill ? (
                                    <a
                                        title="View Settlement Bill"
                                        className="modal-button-black"
                                        href={i.settlement_bill}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        View
                                    </a>
                                ) : "No Proof Attached"}
                            </>
                        )}


                        {/* {console.log(i.settlement_bill, 'settlememnt bill')} */}
                    </span>
                </>) : (
                    <>
                        <span

                            className="request-status ">
                            Account2  Step was skipped
                        </span >
                        <br />
                    </>
                )}


            </td>
        </>
    )
}
const ViewRequestRemarksExpense = ({ i, table, approval_stages_data }) => {
    // console.log(approval_stages_data, table)
    return (
        <>
            <td title="Remarks and Approval Dates" className="table-body">
                {approval_stages_data != null && approval_stages_data != undefined && approval_stages_data.checker ?
                    (
                        <>
                            <span
                                request-status={i.expense_checker_approval_status}
                                className="request-status "
                            >
                                {i.expense_checker_approval_status === "pending"
                                    ? "-"
                                    : i.expense_checker_approval_status === "rejected"
                                        ? `Checker Reject Reason : ${i.checker_rejection_reason}`
                                        : `Checker${i.checker ? `(${i?.checker_name}) ` : ''}: Checked ${i.checker_update_datetime ? `At: ${formatDateTime(i.checker_update_datetime).date}` : ''}`}
                            </span>
                            <br />
                        </>
                    )
                    : (
                        <>
                            <span

                                className="request-status ">
                                Checker  Step was skipped
                            </span >
                            <br />
                        </>
                    )}


                {/* <br /> */}

                {approval_stages_data != null && approval_stages_data != undefined && approval_stages_data.authority ? (<>
                    <span
                        request-status={i.authority_approval_status}
                        className="request-status "
                    >
                        {i.authority_approval_status === "pending"
                            ? "-"
                            : i.authority_approval_status === "rejected"
                                ? `Authority Reject Reason : ${i.authority_rejection_reason}`
                                : `Authority${i.authority_engineer ? `(${i?.authority_engineer_name}) ` : ''}: Verified Amounts for Bills ${i.authority_update_datetime ? `At: ${formatDateTime(i.authority_update_datetime).date}` : ''}`}
                    </span>
                    <br />
                </>) : (
                    <>
                        <span

                            className="request-status ">
                            Authority  Step was skipped
                        </span >
                        <br />
                    </>
                )}

                {/* <br /> */}

                {approval_stages_data != null && approval_stages_data != undefined && approval_stages_data.account ? (<>
                    <span
                        request-status={i.account_status_a}
                        className="request-status "
                    >
                        {i.account_status_a === "pending"
                            ? "-"
                            : i.account_status_a === "rejected"
                                ? `Accounts Reject Reason : ${i.account1_rejection_reason}`
                                : `Accounts${i.account_update_by ? `(${i?.account_update_by_name}) ` : ''}: Bills Verified ${i.account_update_datetime ? `At: ${formatDateTime(i.account_update_datetime).date}` : ''}`}
                    </span>
                    <br />
                </>) : (
                    <>
                        <span

                            className="request-status ">
                            Account1  Step was skipped
                        </span >
                        <br />
                    </>
                )}

                {/* <br /> */}

                {approval_stages_data != null && approval_stages_data != undefined && approval_stages_data.admin1 ? (<>
                    <span
                        request-status={i.admin_approval_status}
                        className="request-status "
                        title={i.admin_approval_status === "rejected" ? `Admin 1 Reject Reason : ${i.admin_rejection_reason_c1}` : ""}
                    >
                        {i.admin_approval_status === "pending"
                            ? "-"
                            : i.admin_approval_status === "rejected"
                                ? `Admin 1 Rejection Reason : ${i.admin_rejection_reason_c1}`
                                : `Admin 1${i.admin_update_by ? `(${i?.admin_update_by_c1_name ? i?.admin_update_by_c1_name : ""}) ` : ''}: Approved After Verification  ${i.admin_update_datetime_c1 ? `At: ${formatDateTime(i.admin_update_datetime_c1).date}` : ''}`}
                    </span>
                    <br />
                </>) : (
                    <>
                        <span

                            className="request-status ">
                            Admin1  Step was skipped
                        </span >
                        <br />
                    </>
                )}

                {approval_stages_data != null && approval_stages_data != undefined && approval_stages_data.admin2 ? (<>

                    <span
                        request-status={i.admin_approval_status_c2}
                        className="request-status "
                        title={i.admin_approval_status_c2 === "rejected" ? `Admin 2 Reject Reason : ${i.admin_rejection_reason_c2}` : ""}
                    >
                        {i.admin_approval_status_c2 === "pending"
                            ? "-"
                            : i.admin_approval_status_c2 === "rejected"
                                ? `Admin 2 Rejection Reason : ${i.admin_rejection_reason_c2}`
                                : `Admin 2${i.admin_update_by_c2 ? `(${i?.admin_update_by_c2_name ? i?.admin_update_by_c2_name : ""}) ` : ''}: Approved After Verification  ${i.admin_update_datetime_c2 ? `At: ${formatDateTime(i.admin_update_datetime_c2).date}` : ''}`}
                    </span>

                    <br />
                </>) : (
                    <>
                        <span

                            className="request-status ">
                            Admin2  Step was skipped
                        </span >
                        <br />
                    </>
                )}

                {approval_stages_data != null && approval_stages_data != undefined && approval_stages_data.admin3 ? (<>

                    <span
                        request-status={i.admin_approval_status_c3}
                        className="request-status "
                        title={i.admin_approval_status_c3 === "rejected" ? `Admin 3 Reject Reason : ${i.admin_rejection_reason_c3}` : ""}
                    >
                        {i.admin_approval_status_c3 === "pending"
                            ? "-"
                            : i.admin_approval_status_c3 === "rejected"
                                ? `Admin 3 Rejection Reason : ${i.admin_rejection_reason_c3}`
                                : `Admin 3${i.admin_update_by_c3 ? `(${i?.admin_update_by_c3_name ? i?.admin_update_by_c3_name : ""}) ` : ''}: Approved After Verification  ${i.admin_update_datetime_c2 ? `At: ${formatDateTime(i.admin_update_datetime_c2).date}` : ''}`}
                    </span>

                    <br />
                </>) : (
                    <>
                        <span

                            className="request-status ">
                            Admin3  Step was skipped
                        </span >
                        <br />
                    </>
                )}

                {approval_stages_data != null && approval_stages_data != undefined && approval_stages_data.payment_settlement ? (<>
                    <span
                        request-status={i.account_status_b}
                        className="request-status "
                        style={{ cursor: "help" }}
                        title={`Transaction/Cheque No.:\n${i.account_status_b !== "pending" ? i.settlement_transaction_id : null}`}
                    >

                        {i.account_status_b === "pending" ? (
                            "-"
                        ) : i.account_status_b === "rejected" ? (
                            `Final Rejection Reason: ${i.account2_rejection_reason}`
                        ) : (
                            <>
                                {`Final${i.final_update_by ? ` (${i.final_update_by_name})` : ''}: Approved And Settled `}
                                {i.final_update_datetime ? `At: ${formatDateTime(i.final_update_datetime).date} ` : ''}
                                {i.settlement_bill ? (
                                    <a
                                        title="View Settlement Bill"
                                        className="modal-button-black"
                                        href={i.settlement_bill}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        View
                                    </a>
                                ) : "No Proof Attached"}
                            </>
                        )}


                        {/* {console.log(i.settlement_bill, 'settlememnt bill')} */}
                    </span>
                </>) : (
                    <>
                        <span

                            className="request-status ">
                            Account2  Step was skipped
                        </span >
                        <br />
                    </>
                )}


            </td>
        </>
    )
}

const ViewRequestRemarksImprest = ({ i, table, approval_stages_data }) => {
    return (
        <>
            <td title="Remarks and Approval Dates" className="table-body">
                {approval_stages_data != null && approval_stages_data != undefined && approval_stages_data.checker ?
                    (
                        <>
                            <span
                                request-status={i.checker_approval_status}
                                className="request-status "
                            >
                                {i.checker_approval_status === "pending"
                                    ? "-"
                                    : i.checker_approval_status === "rejected"
                                        ? `Checker Reject Reason : ${i.checker_rejected_reason}`
                                        : `Checker${i.checker ? `(${i?.checker_name}) ` : ''}: Checked ${i.checker_update_datetime ? `At: ${formatDateTime(i.checker_update_datetime).date}` : ''}`}
                            </span>
                            <br />
                        </>
                    )
                    : (
                        <>
                            <span

                                className="request-status ">
                                Checker  Step was skipped
                            </span >
                            <br />
                        </>
                    )}


                {/* <br /> */}

                {approval_stages_data != null && approval_stages_data != undefined && approval_stages_data.authority ? (<>
                    <span
                        request-status={i.authority_approval_status}
                        className="request-status "
                    >
                        {i.authority_approval_status === "pending"
                            ? "-"
                            : i.authority_approval_status === "rejected"
                                ? `Authority Reject Reason : ${i.authority_rejection_reason}`
                                : `Authority${i.authority_engineer ? `(${i?.authority_engineer_name}) ` : ''}: Verified Amounts for Bills ${i.authority_update_datetime ? `At: ${formatDateTime(i.authority_update_datetime).date}` : ''}`}
                    </span>
                    <br />
                </>) : (
                    <>
                        <span

                            className="request-status ">
                            Authority  Step was skipped
                        </span >
                        <br />
                    </>
                )}
                {approval_stages_data != null && approval_stages_data != undefined && approval_stages_data.account ? (<>
                    <span
                        request-status={i.account_approval_status}
                        className="request-status "
                    >
                        {i.account_approval_status === "pending"
                            ? "-"
                            : i.account_approval_status === "rejected"
                                ? `Accounts Reject Reason : ${i.account1_rejection_reason}`
                                : `Accounts${i.account_update_by ? `(${i?.account_update_by_name}) ` : ''}: Bills Verified ${i.account_update_datetime ? `At: ${formatDateTime(i.account_update_datetime).date}` : ''}`}
                    </span>
                    <br />
                </>) : (
                    <>
                        <span

                            className="request-status ">
                            Account1  Step was skipped
                        </span >
                        <br />
                    </>
                )}
                {/* <br /> */}
                {approval_stages_data != null && approval_stages_data != undefined && approval_stages_data.admin1 ? (<>
                    <span
                        request-status={i.admin_approval_status}
                        className="request-status "
                        title={i.admin_approval_status === "rejected" ? `Admin 1 Reject Reason : ${i.admin_rejection_reason_c1}` : ""}
                    >
                        {i.admin_approval_status === "pending"
                            ? "-"
                            : i.admin_approval_status === "rejected"
                                ? `Admin 1 Rejection Reason : ${i.admin_rejection_reason}`
                                : `Admin 1${i.admin_update_by_c1 ? `(${i?.admin_update_by_c1_name ? i?.admin_update_by_c1_name : ""})) ` : ''}: Approved After Verification  ${i.admin_update_datetime_c1 ? `At: ${formatDateTime(i.admin_update_datetime_c1).date}` : ''}`}
                    </span>
                    <br />
                </>) : (
                    <>
                        <span

                            className="request-status ">
                            Admin1  Step was skipped
                        </span >
                        <br />
                    </>
                )}

                {approval_stages_data != null && approval_stages_data != undefined && approval_stages_data.admin2 ? (<>
                    <span
                        request-status={i.admin_approval_status_c2}
                        className="request-status "
                        title={i.admin_approval_status_c2 === "rejected" ? `Admin 2 Reject Reason : ${i.admin_rejection_reason_c2}` : ""}
                    >
                        {i.admin_approval_status_c2 === "pending"
                            ? "-"
                            : i.admin_approval_status_c2 === "rejected"
                                ? `Admin 2 Rejection Reason : ${i.admin_rejection_reason_c2}`
                                : `Admin 2${i.admin_update_by_c2 ? `(${i?.admin_update_by_c2_name ? i?.admin_update_by_c2_name : ""}) ` : ''}: Approved After Verification  ${i.admin_update_datetime_c2 ? `At: ${formatDateTime(i.admin_update_datetime_c2).date}` : ''}`}
                    </span>

                    <br />
                </>) : (
                    <>
                        <span

                            className="request-status ">
                            Admin2  Step was skipped
                        </span >
                        <br />
                    </>
                )}

                {approval_stages_data != null && approval_stages_data != undefined && approval_stages_data.admin3 ? (<>
                    <span
                        request-status={i.admin_approval_status_c3}
                        className="request-status "
                        title={i.admin_approval_status_c3 === "rejected" ? `Admin 3 Reject Reason : ${i.admin_rejection_reason_c3}` : ""}
                    >
                        {i.admin_approval_status_c3 === "pending"
                            ? "-"
                            : i.admin_approval_status_c3 === "rejected"
                                ? `Admin 3 Rejection Reason : ${i.admin_rejection_reason_c3}`
                                : `Admin 3${i.admin_update_by_c3 ? `(${i?.admin_update_by_c3_name ? i?.admin_update_by_c3_name : ""}) ` : ''}: Approved After Verification  ${i.admin_update_datetime_c2 ? `At: ${formatDateTime(i.admin_update_datetime_c2).date}` : ''}`}
                    </span>

                    <br />
                </>) : (
                    <>
                        <span

                            className="request-status ">
                            Admin3  Step was skipped
                        </span >
                        <br />
                    </>
                )}
                {approval_stages_data != null && approval_stages_data != undefined && approval_stages_data.payment_settlement ? (<>
                    <span
                        request-status={i.account_status_b}
                        className="request-status "
                    >
                        {i.account_status_b === "pending"
                            ? "-"
                            : i.account_status_b === "rejected"
                                ? `Accounts Reject Reason : ${i.account1_rejection_reason}`
                                : `Accounts${i.account_update_by ? `(${i?.account_update_by_name}) ` : ''}: Bills Verified ${i.account_update_datetime ? `At: ${formatDateTime(i.account_update_datetime).date}` : ''}`}
                    </span>
                    <br />
                </>) : (
                    <>
                        <span

                            className="request-status ">
                            Account2  Step was skipped
                        </span >
                        <br />
                    </>
                )}

                {/* <br /> */}





            </td>
        </>
    )
}


const ViewDocumnetsbilling = ({ documentlist }) => {
    return (<>

        {
            documentlist != undefined && documentlist.length > 0 &&
            <table className="table-css documentlistbillingtable">
                <thead>
                    <tr className="custom-table-head-tr ">
                        <th className="table-heading-text">S.No.</th>
                        <th className="table-heading-text">Document Name</th>

                        <th className="table-heading-text">Document Type</th>

                        <th className="table-heading-text text-center">Document</th>
                    </tr>
                </thead>
                <tbody
                >
                    {
                        documentlist
                            .map((doc, docIndex) => (
                                <tr className="custom-table-head-td">

                                    <td className="table-body">{docIndex + 1}.</td>
                                    <td className="table-body">{doc.document_name}</td>
                                    <td className="table-body">{doc.document_type}</td>
                                    <td className="table-body">
                                        {doc.document_file ? (
                                            // <a href={i.document_file} target="blank">
                                            //   View
                                            // </a>
                                            <a href={doc.document_file} target="blank">
                                                <div className="flex-row justify-center">
                                                    <DocumentIcon />
                                                </div>
                                            </a>
                                        ) : (
                                            "Document Not Attached"
                                        )}
                                    </td>


                                </tr>
                            ))
                    }
                </tbody>
            </table>
        }

    </>)
}
const ViewEmployeeList = ({ titlename, sort, list }) => {
    const [show, setShow] = useState(false);
    const [showemployee, setShowemployee] = useState(false);
    const [employeenumbershow, Setemployeenumbershow] = useState(3)
    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
    };

    const handleShowemployee = (empCode) => {
        setShowemployee(empCode);
    };

    return (
        <>
            <button
                title={"View List"}
                style={{ cursor: "pointer" }}
                onClick={handleShow}
            >
                <div className="overlap-image-div " style={{}}>
                    {list?.slice(0, employeenumbershow).map((i, index) => (
                        <>

                            <div className="outer-overlap-image-box" key={index} >
                                <div
                                    className="overlap-image-box"
                                    onMouseEnter={() => handleShowemployee(i.emp_code)}
                                    onMouseLeave={() => handleShowemployee(null)}
                                    style={{ transform: showemployee === i.emp_code ? "scale(1.2)" : "scale(0.9)" }}
                                >
                                    <img
                                        src={
                                            i.profilepic
                                                ? i.profilepic
                                                : "https://images.unsplash.com/photo-1511367461989-f85a21fda167?q=80&w=1931&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                                        }
                                        alt={`${i.name} pic`}
                                        className="profile-img overlap-img"

                                    />
                                </div>
                                {showemployee === i.emp_code && (
                                    <div className="overlap-employee-details">
                                        {i.emp_code}
                                        <br />
                                        {i.name}
                                    </div>
                                )}
                            </div>
                        </>
                    ))}
                    {list && list.length > employeenumbershow && (
                        <div className="dots-container">
                            {Array.from({ length: Math.ceil((list.length - employeenumbershow) / 1) }).map((_, i) => (
                                <span key={i} className="dot"></span>
                            ))}
                        </div>
                    )}
                    {list && list.length > employeenumbershow && (
                        <div className="add-more-container">
                            <span className="add-more-text">+More</span>
                        </div>
                    )}

                </div>
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>{titlename}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <table className="table-css">
                            <thead>
                                <tr className="custom-table-head-invoices">
                                    <th className="align-center font-size-text font-weight600">
                                        Sr no.
                                    </th>
                                    <th className="align-center font-size-text font-weight600">
                                        Profile pic
                                    </th>
                                    <th className="align-center font-size-text font-weight600">
                                        Employee code
                                    </th>
                                    <th className="align-center font-size-text font-weight600">
                                        Employee Name
                                    </th>
                                </tr>{" "}
                            </thead>
                            <tbody>
                                {list?.map((i, index) => (
                                    <>
                                        <tr className="custom-table-head-td">
                                            <td className="align-left">{index + 1}</td>
                                            <td className="align-center">
                                                <img
                                                    src={
                                                        i.profilepic
                                                            ? i.profilepic
                                                            : "https://images.unsplash.com/photo-1511367461989-f85a21fda167?q=80&w=1931&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                                                    }
                                                    alt={`${i.name} pic`}
                                                    className="profile-img"
                                                />
                                            </td>
                                            <td className="align-center">{i.emp_code}</td>
                                            <td className="align-center">{i.name}</td>
                                        </tr>
                                    </>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

const HandleDownloadTableasExcel = ({ tableRef }) => {



    const handleDownloadTable = () => {
        const table = tableRef.current;

        // Prepare table data and column headers
        const rows = [];
        const tableRows = table.querySelectorAll('thead tr, tbody tr');
        // console.log(tableRows)
        tableRows.forEach(row => {
            const rowData = [];
            const cells = row.querySelectorAll('th, td');
            cells.forEach(cell => {
                rowData.push(cell.innerText.trim());
            });
            rows.push(rowData);
        });
        console.log(rows, 'rows')
        // Create a workbook
        const ws = XLSX.utils.aoa_to_sheet(rows);

        // Adjust column width dynamically based on content length
        // const colWidths = rows[0].map((_, colIndex) => {
        //     const maxLength = Math.max(...rows.map(row => row[colIndex].length));
        //     return { wpx: maxLength * 10 }; // Adjust width as needed (multiplier of 10 is for better appearance)
        // });
        // ws['!cols'] = colWidths;

        // Create the workbook and download it
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
        XLSX.writeFile(wb, 'table_data.xlsx');
    };

    return (
        <button onClick={handleDownloadTable} title="Download" className="model-button font-weight500 model-button-print" style={{ margin: "2px" }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" id="download" fill="#fff">
                <g fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                    <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M6 11l4 4 4-4M10 1v14"></path>
                </g>
            </svg>
        </button>
    );
};

const CHUNK_SIZE = 10 * 1024 * 1024; // 5MB chunk size

const CSSForSelectSmallWidth = {
    control: (provided) => ({
        ...provided,
        width: '20vw',
        height: '50px',
        borderRadius: '10px',
        border: '1px solid #e3e3e3',
        margin: '10px 0px 20px 0px',
        color: '#4a4a4a',
        backgroundColor: '#f7f8fa',
        padding: '0px 10px',
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#4a4a4a',
    }),
    menu: (provided) => ({
        ...provided,
        width: '20vw',
        borderRadius: '10px',
        marginTop: '0',
        zIndex: 5,
    }),
    menuPortal: (provided) => ({
        ...provided,
        zIndex: 5,
    }),
    singleValue: (provided) => ({
        ...provided,
        color: '#4a4a4a',
    }),
    input: (provided) => ({
        ...provided,
        color: '#4a4a4a',
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isFocused
            ? '#cce4ff'
            : state.isSelected
                ? '#f7f8fa'
                : '#ffffff',
        color: '#4a4a4a',
        cursor: 'pointer',
        ':active': {
            backgroundColor: '#cce4ff',
        },
    }),
};


const CSSForMultiSelectOption = {
    control: (provided) => ({
        ...provided,
        width: '40vw',
        minHeight: '50px',
        borderRadius: '10px',
        border: '1px solid #e3e3e3',
        margin: '10px 0px 20px 0px',
        color: '#4a4a4a',
        backgroundColor: '#f7f8fa',
        padding: '0px 10px',
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#4a4a4a',
    }),
    menu: (provided) => ({
        ...provided,
        width: '33vw',
        borderRadius: '10px',
        marginTop: '0',
    }),
    singleValue: (provided) => ({
        ...provided,
        color: '#4a4a4a',
    }),
    input: (provided) => ({
        ...provided,
        color: '#4a4a4a',
    }),
}
const CSSForMultiSelectOptionModern = {
    control: (provided) => ({
        ...provided,
        width: '23vw',
        minHeight: '50px',
        borderRadius: '10px',
        border: '1px solid #e3e3e3',
        margin: '10px 0px 20px 0px',
        color: '#4a4a4a',
        backgroundColor: '#f7f8fa',
        padding: '0px 10px',
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#4a4a4a',
    }),
    menu: (provided) => ({
        ...provided,
        width: '23vw',
        borderRadius: '10px',
        marginTop: '0',
    }),
    singleValue: (provided) => ({
        ...provided,
        color: '#4a4a4a',
    }),
    input: (provided) => ({
        ...provided,
        color: '#4a4a4a',
    }),
}
const CSSForMultiSelectOptionNew = {
    control: (provided) => ({
        ...provided,
        width: '33vw',
        minHeight: '50px',
        borderRadius: '10px',
        border: '1px solid #e3e3e3',
        margin: '10px 0px 20px 0px',
        color: '#4a4a4a',
        backgroundColor: '#f7f8fa',
        padding: '0px 10px',
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#4a4a4a',
    }),
    menu: (provided) => ({
        ...provided,
        width: '33vw',
        borderRadius: '10px',
        marginTop: '0',
    }),
    singleValue: (provided) => ({
        ...provided,
        color: '#4a4a4a',
    }),
    input: (provided) => ({
        ...provided,
        color: '#4a4a4a',
    }),
}

const CSSForSelect10vWWidth = {
    control: (provided) => ({
        ...provided,
        width: '10vw',
        height: '50px',
        borderRadius: '10px',
        border: '1px solid #e3e3e3',
        margin: '10px 0px 20px 0px',
        color: '#4a4a4a',
        backgroundColor: '#f7f8fa',
        padding: '0px 10px',
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#4a4a4a',
    }),
    menu: (provided) => ({
        ...provided,
        width: '10vw',
        borderRadius: '10px',
        marginTop: '0',
        zIndex: 5,
    }),
    menuPortal: (provided) => ({
        ...provided,
        zIndex: 5,
    }),
    singleValue: (provided) => ({
        ...provided,
        color: '#4a4a4a',
    }),
    input: (provided) => ({
        ...provided,
        color: '#4a4a4a',
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isFocused
            ? '#cce4ff'
            : state.isSelected
                ? '#f7f8fa'
                : '#ffffff',
        color: '#4a4a4a',
        cursor: 'pointer',
        ':active': {
            backgroundColor: '#cce4ff',
        },
    }),
};
const CSSForSelect15vWWidthvwWithourforntSize = {
    control: (provided) => ({
        ...provided,
        width: '15vw',
        height: '50px',
        borderRadius: '10px',
        border: '1px solid #e3e3e3',
        margin: '10px 0px 20px 0px',
        color: '#4a4a4a',
        backgroundColor: '#f7f8fa',
        padding: '0px 10px',
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#4a4a4a',
    }),
    menu: (provided) => ({
        ...provided,
        width: '15vw',
        borderRadius: '10px',
        marginTop: '0',
        zIndex: 5,
    }),
    menuPortal: (provided) => ({
        ...provided,
        zIndex: 5,
    }),
    singleValue: (provided) => ({
        ...provided,
        color: '#4a4a4a',
    }),
    input: (provided) => ({
        ...provided,
        color: '#4a4a4a',
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isFocused
            ? '#cce4ff'
            : state.isSelected
                ? '#f7f8fa'
                : '#ffffff',
        color: '#4a4a4a',
        cursor: 'pointer',
        ':active': {
            backgroundColor: '#cce4ff',
        },
    }),
};

const CSSForSelect15vWWidth = {
    control: (provided) => ({
        ...provided,
        width: '15vw',
        height: '50px',
        borderRadius: '10px',
        border: '1px solid #e3e3e3',
        margin: '10px 0px 20px 0px',
        color: '#4a4a4a',
        backgroundColor: '#f7f8fa',
        padding: '0px 10px',
        fontSize: '14px',
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#4a4a4a',
    }),
    menu: (provided) => ({
        ...provided,
        width: '17vw',
        borderRadius: '10px',
        marginTop: '0',
        zIndex: 5,
        fontSize: '20px', // <-- Optional, menu font size
    }),
    menuPortal: (provided) => ({
        ...provided,
        zIndex: 5,
    }),
    singleValue: (provided) => ({
        ...provided,
        color: '#4a4a4a',
        fontSize: '13px',
    }),
    input: (provided) => ({
        ...provided,
        color: '#4a4a4a',
        fontSize: '14px',
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isFocused
            ? 'black'
            : state.isSelected
                ? 'black'
                : '#ffffff',
        color: state.isSelected ? 'white' : state.isFocused ? 'white' : "grey",
        cursor: 'pointer',
        width: "15vw",
        fontSize: '12px',
        ':active': {
            backgroundColor: '#cce4ff',
        },
    }),
};


const CSSForSelectModern = {
    control: (provided, state) => ({
        ...provided,
        width: '23vw',
        // minHeight: '38px',
        height: 'auto',
        borderRadius: '0.75rem',
        border: state.isFocused ? '1px solid #667eea' : '1px solid #e2e8f0',
        // margin: '10px 0px 20px 0px',
        color: '#1e293b',
        backgroundColor: '#ffffff',
        padding: '0.125rem 0.875rem',
        fontSize: '0.875rem',
        transition: 'all 0.2s ease',
        fontFamily: 'inherit',
        boxShadow: state.isFocused ? '0 0 0 3px rgba(102, 126, 234, 0.1)' : 'none',
        cursor: 'pointer',
        '&:hover': {
            borderColor: '#cbd5e1',
        },
    }),
    placeholder: (provided) => ({
        ...provided,
        color: 'black',
        fontSize: '0.875rem',
        fontWeight: '400',
    }),
    menu: (provided) => ({
        ...provided,
        width: '25vw',
        borderRadius: '0.75rem',
        marginTop: '4px',
        zIndex: 5,
        backgroundColor: '#ffffff',
        border: '1px solid #e2e8f0',
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
        overflow: 'hidden',
    }),
    menuPortal: (provided) => ({
        ...provided,
        zIndex: 10000,
    }),
    menuList: (provided) => ({
        ...provided,
        padding: '4px',
        maxHeight: '200px',
        '&::-webkit-scrollbar': {
            width: '4px',
        },
        '&::-webkit-scrollbar-track': {
            background: '#f1f5f9',
            borderRadius: '4px',
        },
        '&::-webkit-scrollbar-thumb': {
            background: '#cbd5e1',
            borderRadius: '4px',
        },
    }),
    singleValue: (provided) => ({
        ...provided,
        color: '#1e293b',
        fontSize: '0.875rem',
        fontWeight: '500',
    }),
    input: (provided) => ({
        ...provided,
        color: '#1e293b',
        fontSize: '0.875rem',
        margin: '0',
        padding: '0',
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isFocused
            ? 'black'
            : state.isSelected
                ? 'black'
                : '#ffffff',
        color: state.isSelected ? 'white' : state.isFocused ? 'white' : "grey",
        cursor: 'pointer',
        fontSize: '0.8125rem',
        width: "23vw",
        padding: '0.5rem 0.75rem',
        borderRadius: '0.5rem',
        margin: '2px 0',
        transition: 'all 0.2s',
        fontFamily: 'inherit',
        '&:active': {
            backgroundColor: '#e2e8f0',
        },
    }),
    indicatorSeparator: (provided) => ({
        ...provided,
        backgroundColor: '#e2e8f0',
        margin: '8px 0',
    }),
    dropdownIndicator: (provided, state) => ({
        ...provided,
        color: '#94a3b8',
        padding: '4px',
        transition: 'transform 0.2s ease',
        transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : 'rotate(0deg)',
        '&:hover': {
            color: '#667eea',
        },
    }),
    clearIndicator: (provided) => ({
        ...provided,
        color: '#94a3b8',
        padding: '4px',
        '&:hover': {
            color: '#ef4444',
        },
    }),
    multiValue: (provided) => ({
        ...provided,
        backgroundColor: '#eef2ff',
        borderRadius: '0.5rem',
        padding: '2px 4px',
    }),
    multiValueLabel: (provided) => ({
        ...provided,
        color: '#667eea',
        fontSize: '0.75rem',
        fontWeight: '500',
    }),
    multiValueRemove: (provided) => ({
        ...provided,
        color: '#667eea',
        borderRadius: '0.25rem',
        '&:hover': {
            backgroundColor: '#fee2e2',
            color: '#ef4444',
        },
    }),
    noOptionsMessage: (provided) => ({
        ...provided,
        color: '#94a3b8',
        fontSize: '0.75rem',
        padding: '1rem',
        textAlign: 'center',
    }),
    loadingMessage: (provided) => ({
        ...provided,
        color: '#94a3b8',
        fontSize: '0.75rem',
        padding: '1rem',
        textAlign: 'center',
    }),
};
const CSSForSelectModern15VWWidth = {
    control: (provided, state) => ({
        ...provided,
        width: '15vw',
        // minHeight: '38px',
        height: 'auto',
        borderRadius: '0.75rem',
        border: state.isFocused ? '1px solid #667eea' : '1px solid #e2e8f0',
        // margin: '10px 0px 20px 0px',
        color: '#1e293b',
        backgroundColor: '#ffffff',
        padding: '0.125rem 0.875rem',
        fontSize: '0.875rem',
        transition: 'all 0.2s ease',
        fontFamily: 'inherit',
        boxShadow: state.isFocused ? '0 0 0 3px rgba(102, 126, 234, 0.1)' : 'none',
        cursor: 'pointer',
        '&:hover': {
            borderColor: '#cbd5e1',
        },
    }),
    placeholder: (provided) => ({
        ...provided,
        color: 'black',
        fontSize: '0.875rem',
        fontWeight: '400',
    }),
    menu: (provided) => ({
        ...provided,
        width: '17vw',
        borderRadius: '0.75rem',
        marginTop: '4px',
        zIndex: 5,
        backgroundColor: '#ffffff',
        border: '1px solid #e2e8f0',
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
        overflow: 'hidden',
    }),
    menuPortal: (provided) => ({
        ...provided,
        zIndex: 10,
    }),
    menuList: (provided) => ({
        ...provided,
        padding: '4px',
        maxHeight: '200px',
        '&::-webkit-scrollbar': {
            width: '4px',
        },
        '&::-webkit-scrollbar-track': {
            background: '#f1f5f9',
            borderRadius: '4px',
        },
        '&::-webkit-scrollbar-thumb': {
            background: '#cbd5e1',
            borderRadius: '4px',
        },
    }),
    singleValue: (provided) => ({
        ...provided,
        color: '#1e293b',
        fontSize: '0.875rem',
        fontWeight: '500',
    }),
    input: (provided) => ({
        ...provided,
        color: '#1e293b',
        fontSize: '0.875rem',
        margin: '0',
        padding: '0',
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isFocused
            ? 'black'
            : state.isSelected
                ? 'black'
                : '#ffffff',
        color: state.isSelected ? 'white' : state.isFocused ? 'white' : "grey",
        cursor: 'pointer',
        width: "15vw",
        fontSize: '0.8125rem',
        padding: '0.5rem 0.75rem',
        borderRadius: '0.5rem',
        margin: '2px 0',
        transition: 'all 0.2s',
        fontFamily: 'inherit',
        '&:active': {
            backgroundColor: '#e2e8f0',
        },
    }),
    indicatorSeparator: (provided) => ({
        ...provided,
        backgroundColor: '#e2e8f0',
        margin: '8px 0',
    }),
    dropdownIndicator: (provided, state) => ({
        ...provided,
        color: '#94a3b8',
        padding: '4px',
        transition: 'transform 0.2s ease',
        transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : 'rotate(0deg)',
        '&:hover': {
            color: '#667eea',
        },
    }),
    clearIndicator: (provided) => ({
        ...provided,
        color: '#94a3b8',
        padding: '4px',
        '&:hover': {
            color: '#ef4444',
        },
    }),
    multiValue: (provided) => ({
        ...provided,
        backgroundColor: '#eef2ff',
        borderRadius: '0.5rem',
        padding: '2px 4px',
    }),
    multiValueLabel: (provided) => ({
        ...provided,
        color: '#667eea',
        fontSize: '0.75rem',
        fontWeight: '500',
    }),
    multiValueRemove: (provided) => ({
        ...provided,
        color: '#667eea',
        borderRadius: '0.25rem',
        '&:hover': {
            backgroundColor: '#fee2e2',
            color: '#ef4444',
        },
    }),
    noOptionsMessage: (provided) => ({
        ...provided,
        color: '#94a3b8',
        fontSize: '0.75rem',
        padding: '1rem',
        textAlign: 'center',
    }),
    loadingMessage: (provided) => ({
        ...provided,
        color: '#94a3b8',
        fontSize: '0.75rem',
        padding: '1rem',
        textAlign: 'center',
    }),
};
const CSSForSelectModern10VWWidth = {
    control: (provided, state) => ({
        ...provided,
        width: '10vw',
        // minHeight: '38px',
        height: 'auto',
        borderRadius: '0.75rem',
        border: state.isFocused ? '1px solid #667eea' : '1px solid #e2e8f0',
        // margin: '10px 0px 20px 0px',
        color: '#1e293b',
        backgroundColor: '#ffffff',
        padding: '0.125rem 0.875rem',
        fontSize: '0.875rem',
        transition: 'all 0.2s ease',
        fontFamily: 'inherit',
        boxShadow: state.isFocused ? '0 0 0 3px rgba(102, 126, 234, 0.1)' : 'none',
        cursor: 'pointer',
        '&:hover': {
            borderColor: '#cbd5e1',
        },
    }),
    placeholder: (provided) => ({
        ...provided,
        color: 'black',
        fontSize: '0.875rem',
        fontWeight: '400',
    }),
    menu: (provided) => ({
        ...provided,
        width: '12vw',
        borderRadius: '0.75rem',
        marginTop: '4px',
        zIndex: 5,
        backgroundColor: '#ffffff',
        border: '1px solid #e2e8f0',
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
        overflow: 'hidden',
    }),
    menuPortal: (provided) => ({
        ...provided,
        zIndex: 10,
    }),
    menuList: (provided) => ({
        ...provided,
        padding: '4px',
        maxHeight: '200px',
        '&::-webkit-scrollbar': {
            width: '4px',
        },
        '&::-webkit-scrollbar-track': {
            background: '#f1f5f9',
            borderRadius: '4px',
        },
        '&::-webkit-scrollbar-thumb': {
            background: '#cbd5e1',
            borderRadius: '4px',
        },
    }),
    singleValue: (provided) => ({
        ...provided,
        color: '#1e293b',
        fontSize: '0.875rem',
        fontWeight: '500',
    }),
    input: (provided) => ({
        ...provided,
        color: '#1e293b',
        fontSize: '0.875rem',
        margin: '0',
        padding: '0',
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isFocused
            ? 'black'
            : state.isSelected
                ? 'black'
                : '#ffffff',
        color: state.isSelected ? 'white' : state.isFocused ? 'white' : "grey",
        cursor: 'pointer',
        width: "10vw",
        fontSize: '0.8125rem',
        padding: '0.5rem 0.75rem',
        borderRadius: '0.5rem',
        margin: '2px 0',
        transition: 'all 0.2s',
        fontFamily: 'inherit',
        '&:active': {
            backgroundColor: '#e2e8f0',
        },
    }),
    indicatorSeparator: (provided) => ({
        ...provided,
        backgroundColor: '#e2e8f0',
        margin: '8px 0',
    }),
    dropdownIndicator: (provided, state) => ({
        ...provided,
        color: '#94a3b8',
        padding: '4px',
        transition: 'transform 0.2s ease',
        transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : 'rotate(0deg)',
        '&:hover': {
            color: '#667eea',
        },
    }),
    clearIndicator: (provided) => ({
        ...provided,
        color: '#94a3b8',
        padding: '4px',
        '&:hover': {
            color: '#ef4444',
        },
    }),
    multiValue: (provided) => ({
        ...provided,
        backgroundColor: '#eef2ff',
        borderRadius: '0.5rem',
        padding: '2px 4px',
    }),
    multiValueLabel: (provided) => ({
        ...provided,
        color: '#667eea',
        fontSize: '0.75rem',
        fontWeight: '500',
    }),
    multiValueRemove: (provided) => ({
        ...provided,
        color: '#667eea',
        borderRadius: '0.25rem',
        '&:hover': {
            backgroundColor: '#fee2e2',
            color: '#ef4444',
        },
    }),
    noOptionsMessage: (provided) => ({
        ...provided,
        color: '#94a3b8',
        fontSize: '0.75rem',
        padding: '1rem',
        textAlign: 'center',
    }),
    loadingMessage: (provided) => ({
        ...provided,
        color: '#94a3b8',
        fontSize: '0.75rem',
        padding: '1rem',
        textAlign: 'center',
    }),
};

// Media query for mobile responsiveness
if (typeof window !== 'undefined' && window.innerWidth <= 768) {
    CSSForSelect15vWWidth.control.width = '100%';
    CSSForSelect15vWWidth.menu.width = '100%';
}

const CSSForSelect20vWWidth = {
    control: (provided) => ({
        ...provided,
        width: '20vw',
        height: '50px',
        borderRadius: '10px',
        border: '1px solid #e3e3e3',
        margin: '10px 0px 20px 0px',
        color: '#4a4a4a',
        backgroundColor: '#f7f8fa',
        padding: '0px 10px',
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#4a4a4a',
    }),
    menu: (provided) => ({
        ...provided,
        width: '20vw',
        borderRadius: '10px',
        marginTop: '0',
        zIndex: 5,
    }),
    menuPortal: (provided) => ({
        ...provided,
        zIndex: 5,
    }),
    singleValue: (provided) => ({
        ...provided,
        color: '#4a4a4a',
    }),
    input: (provided) => ({
        ...provided,
        color: '#4a4a4a',
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isFocused
            ? '#cce4ff'
            : state.isSelected
                ? '#f7f8fa'
                : '#ffffff',
        color: '#4a4a4a',
        cursor: 'pointer',
        ':active': {
            backgroundColor: '#cce4ff',
        },
    }),
};

const CSSForSelect23vWWidth = {
    control: (provided) => ({
        ...provided,
        width: '23vw',
        height: '50px',
        borderRadius: '10px',
        border: '1px solid #e3e3e3',
        margin: '10px 0px 20px 0px',
        color: '#4a4a4a',
        backgroundColor: '#f7f8fa',
        padding: '0px 10px',
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#4a4a4a',
    }),
    menu: (provided) => ({
        ...provided,
        width: '23vw',
        borderRadius: '10px',
        marginTop: '0',
        zIndex: 5,
    }),
    menuPortal: (provided) => ({
        ...provided,
        zIndex: 5,
    }),
    singleValue: (provided) => ({
        ...provided,
        color: '#4a4a4a',
    }),
    input: (provided) => ({
        ...provided,
        color: '#4a4a4a',
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isFocused
            ? '#cce4ff'
            : state.isSelected
                ? '#f7f8fa'
                : '#ffffff',
        color: '#4a4a4a',
        cursor: 'pointer',
        ':active': {
            backgroundColor: '#cce4ff',
        },
    }),
};




// const CSSForFilterDropdown = {
//     control: (provided, state) => ({
//         ...provided,
//         backgroundColor: "transparent",
//         border: "none",
//         boxShadow: "none",
//         minHeight: "42px",
//         cursor: "pointer",
//         '&:hover': {
//             backgroundColor: "transparent",
//         },
//         minWidth: "20vw",
//     }),
//     placeholder: (provided) => ({
//         ...provided,
//         color: "black",
//         fontSize: "1em",
//     }),
//     valueContainer: (provided) => ({
//         ...provided,
//         padding: "0.25rem 0.75rem",
//     }),
//     input: (provided) => ({
//         ...provided,
//         color: "#1e293b",
//         fontSize: "0.8125rem",
//         margin: 0,
//         padding: 0,
//     }),
//     singleValue: (provided) => ({
//         ...provided,
//         color: "#1e293b",
//         fontSize: "0.8125rem",
//         fontWeight: 500,
//     }),
//     menu: (provided) => ({
//         ...provided,
//         zIndex: 2,
//         borderRadius: "0.75rem",
//         boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
//         marginTop: "4px",
//         overflow: "hidden",
//         animation: "dropdownSlide 0.2s ease-out",
//     }),
//     menuPortal: (base) => ({
//         ...base,
//         zIndex: 2
//     }),
//     menuList: (provided) => ({
//         ...provided,
//         padding: "0.25rem",
//         maxHeight: "280px",
//         '&::-webkit-scrollbar': {
//             width: "4px",
//         },
//         '&::-webkit-scrollbar-track': {
//             background: "#f1f5f9",
//             borderRadius: "2px",
//         },
//         '&::-webkit-scrollbar-thumb': {
//             background: "#cbd5e1",
//             borderRadius: "2px",
//         },
//     }),
//     option: (provided, state) => ({
//         ...provided,
//         fontSize: "0.8125rem",
//         padding: "0.625rem 0.75rem",
//         borderRadius: "0.5rem",
//         width: "85%",
//         margin: "0.125rem",
//         color: state.isSelected ? "#ffffff" : "#1e293b",
//         backgroundColor: state.isSelected ? "black" : state.isFocused ? "#f1f5f9" : "#ffffff",
//         cursor: "pointer",
//         transition: "all 0.2s",
//         "&:hover": {
//             backgroundColor: state.isSelected ? "black" : "#f1f5f9",
//         },
//     }),
//     dropdownIndicator: (provided, state) => ({
//         ...provided,
//         color: "#94a3b8",
//         padding: "0.5rem",
//         cursor: "pointer",
//         transition: "transform 0.2s ease",
//         transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : "rotate(0deg)",
//         "&:hover": {
//             color: "#4f46e5",
//         },
//     }),
//     clearIndicator: (provided) => ({
//         ...provided,
//         color: "#94a3b8",
//         padding: "0.5rem",
//         cursor: "pointer",
//         "&:hover": {
//             color: "#ef4444",
//         },
//     }),
//     indicatorSeparator: () => ({
//         display: "none",
//     }),
//     loadingIndicator: (provided) => ({
//         ...provided,
//         color: "#4f46e5",
//     }),
//     loadingMessage: (provided) => ({
//         ...provided,
//         color: "#64748b",
//         fontSize: "0.75rem",
//         padding: "1rem",
//         textAlign: "center",
//     }),
//     noOptionsMessage: (provided) => ({
//         ...provided,
//         color: "#64748b",
//         fontSize: "0.75rem",
//         padding: "1rem",
//         textAlign: "center",
//     }),
// };

const CSSForFilterDropdown = {
    control: (provided, state) => ({
        ...provided,
        border: "none",
        boxShadow: "none",
        minHeight: "42px",
        cursor: "pointer",

        minWidth: "20vw",
    }),
    placeholder: (provided) => ({
        ...provided,
        color: "black",
        fontSize: "0.875em",
    }),
    valueContainer: (provided) => ({
        ...provided,
        padding: "0.25rem 0.75rem",
    }),
    input: (provided) => ({
        ...provided,
        color: "#1e293b",
        fontSize: "0.8125rem",
        margin: 0,
        padding: 0,
    }),
    singleValue: (provided) => ({
        ...provided,
        color: "#1e293b",
        fontSize: "0.8125rem",
        fontWeight: 500,
    }),
    menu: (provided) => ({
        ...provided,
        zIndex: 9999, // Increased z-index to be above modal (modal is usually 1050)
        borderRadius: "0.75rem",
        boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
        marginTop: "4px",
        overflow: "hidden",
        animation: "dropdownSlide 0.2s ease-out",
    }),
    menuPortal: (base) => ({
        ...base,
        zIndex: 9999, // Important for portal rendering
    }),
    menuList: (provided) => ({
        ...provided,
        padding: "0.25rem",
        maxHeight: "280px",
        '&::-webkit-scrollbar': {
            width: "4px",
        },
        '&::-webkit-scrollbar-track': {
            background: "#f1f5f9",
            borderRadius: "2px",
        },
        '&::-webkit-scrollbar-thumb': {
            background: "#cbd5e1",
            borderRadius: "2px",
        },
    }),
    option: (provided, state) => ({
        ...provided,
        fontSize: "0.8125rem",
        padding: "0.625rem 0.75rem",
        borderRadius: "0.5rem",
        width: "85%",
        margin: "0.125rem",
        color: state.isSelected ? "#ffffff" : "#1e293b",
        backgroundColor: state.isSelected ? "black" : state.isFocused ? "#f1f5f9" : "#ffffff",
        cursor: "pointer",
        transition: "all 0.2s",
        "&:hover": {
            backgroundColor: state.isSelected ? "black" : "#f1f5f9",
        },
    }),
    dropdownIndicator: (provided, state) => ({
        ...provided,
        color: "#94a3b8",
        padding: "0.5rem",
        cursor: "pointer",
        transition: "transform 0.2s ease",
        transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : "rotate(0deg)",
        "&:hover": {
            color: "#4f46e5",
        },
    }),
    clearIndicator: (provided) => ({
        ...provided,
        color: "#94a3b8",
        padding: "0.5rem",
        cursor: "pointer",
        "&:hover": {
            color: "#ef4444",
        },
    }),
    indicatorSeparator: () => ({
        display: "none",
    }),
    loadingIndicator: (provided) => ({
        ...provided,
        color: "#4f46e5",
    }),
    loadingMessage: (provided) => ({
        ...provided,
        color: "#64748b",
        fontSize: "0.75rem",
        padding: "1rem",
        textAlign: "center",
    }),
    noOptionsMessage: (provided) => ({
        ...provided,
        color: "#64748b",
        fontSize: "0.75rem",
        padding: "1rem",
        textAlign: "center",
    }),
};
const CSSForFilterDropdown10VW = {
    control: (provided, state) => ({
        ...provided,
        backgroundColor: "white",
        border: "none",
        boxShadow: "none",
        minHeight: "42px",
        cursor: "pointer",
        '&:hover': {
            backgroundColor: "white",
        },
        minWidth: "15vw",
    }),
    placeholder: (provided) => ({
        ...provided,
        color: "black",
        fontSize: "0.875em",
    }),
    valueContainer: (provided) => ({
        ...provided,
        padding: "0.25rem 0.75rem",
    }),
    input: (provided) => ({
        ...provided,
        color: "#1e293b",
        fontSize: "0.8125rem",
        margin: 0,
        padding: 0,
    }),
    singleValue: (provided) => ({
        ...provided,
        color: "#1e293b",
        fontSize: "0.8125rem",
        fontWeight: 500,
    }),
    menu: (provided) => ({
        ...provided,
        zIndex: 9999, // Increased z-index to be above modal (modal is usually 1050)
        borderRadius: "0.75rem",
        boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
        marginTop: "4px",
        overflow: "hidden",
        animation: "dropdownSlide 0.2s ease-out",
    }),
    menuPortal: (base) => ({
        ...base,
        zIndex: 9999, // Important for portal rendering
    }),
    menuList: (provided) => ({
        ...provided,
        padding: "0.25rem",
        maxHeight: "280px",
        '&::-webkit-scrollbar': {
            width: "4px",
        },
        '&::-webkit-scrollbar-track': {
            background: "#f1f5f9",
            borderRadius: "2px",
        },
        '&::-webkit-scrollbar-thumb': {
            background: "#cbd5e1",
            borderRadius: "2px",
        },
    }),
    option: (provided, state) => ({
        ...provided,
        fontSize: "0.8125rem",
        padding: "0.625rem 0.75rem",
        borderRadius: "0.5rem",
        width: "85%",
        margin: "0.125rem",
        color: state.isSelected ? "#ffffff" : "#1e293b",
        backgroundColor: state.isSelected ? "black" : state.isFocused ? "#f1f5f9" : "#ffffff",
        cursor: "pointer",
        transition: "all 0.2s",
        "&:hover": {
            backgroundColor: state.isSelected ? "black" : "#f1f5f9",
        },
    }),
    dropdownIndicator: (provided, state) => ({
        ...provided,
        color: "#94a3b8",
        padding: "0.5rem",
        cursor: "pointer",
        transition: "transform 0.2s ease",
        transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : "rotate(0deg)",
        "&:hover": {
            color: "#4f46e5",
        },
    }),
    clearIndicator: (provided) => ({
        ...provided,
        color: "#94a3b8",
        padding: "0.5rem",
        cursor: "pointer",
        "&:hover": {
            color: "#ef4444",
        },
    }),
    indicatorSeparator: () => ({
        display: "none",
    }),
    loadingIndicator: (provided) => ({
        ...provided,
        color: "#4f46e5",
    }),
    loadingMessage: (provided) => ({
        ...provided,
        color: "#64748b",
        fontSize: "0.75rem",
        padding: "1rem",
        textAlign: "center",
    }),
    noOptionsMessage: (provided) => ({
        ...provided,
        color: "#64748b",
        fontSize: "0.75rem",
        padding: "1rem",
        textAlign: "center",
    }),
};

const getCSSForFilterDropdown = (usedIn) => ({
    control: (provided, state) => ({
        ...provided,
        backgroundColor: "white",
        border: "none",
        boxShadow: "none",
        minHeight: "42px",
        cursor: "pointer",
        '&:hover': {
            backgroundColor: "white",
        },
        minWidth: usedIn === "5" ? "5vw" : usedIn === "40" ? "40vw" : "15vw",
    }),
    placeholder: (provided) => ({
        ...provided,
        color: "black",
        fontSize: "1em",
    }),
    valueContainer: (provided) => ({
        ...provided,
        padding: "0.25rem 0.75rem",
    }),
    input: (provided) => ({
        ...provided,
        color: "#1e293b",
        fontSize: "0.8125rem",
        margin: 0,
        padding: 0,
    }),
    singleValue: (provided) => ({
        ...provided,
        color: "#1e293b",
        fontSize: "0.8125rem",
        fontWeight: 500,
    }),
    menu: (provided) => ({
        ...provided,
        zIndex: 999999,
        borderRadius: "0.75rem",
        boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
        marginTop: "4px",
        overflow: "hidden",
        animation: "dropdownSlide 0.2s ease-out",
    }),
    menuPortal: (base) => ({
        ...base,
        zIndex: 999999,
    }),
    menuList: (provided) => ({
        ...provided,
        padding: "0.25rem",
        maxHeight: "280px",
        '&::-webkit-scrollbar': {
            width: "4px",
        },
        '&::-webkit-scrollbar-track': {
            background: "#f1f5f9",
            borderRadius: "2px",
        },
        '&::-webkit-scrollbar-thumb': {
            background: "#cbd5e1",
            borderRadius: "2px",
        },
    }),
    option: (provided, state) => ({
        ...provided,
        fontSize: "0.8125rem",
        padding: "0.625rem 0.75rem",
        borderRadius: "0.5rem",
        width: usedIn === "5" ? "75%" : "85vw",
        margin: "0.125rem",
        color: state.isSelected ? "#ffffff" : "#1e293b",
        backgroundColor: state.isSelected ? "black" : state.isFocused ? "#f1f5f9" : "#ffffff",
        cursor: "pointer",
        transition: "all 0.2s",
        "&:hover": {
            backgroundColor: state.isSelected ? "black" : "#f1f5f9",
        },
    }),
    dropdownIndicator: (provided, state) => ({
        ...provided,
        color: "#94a3b8",
        padding: "0.5rem",
        cursor: "pointer",
        transition: "transform 0.2s ease",
        transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : "rotate(0deg)",
        "&:hover": {
            color: "#4f46e5",
        },
    }),
    clearIndicator: (provided) => ({
        ...provided,
        color: "#94a3b8",
        padding: "0.5rem",
        cursor: "pointer",
        "&:hover": {
            color: "#ef4444",
        },
    }),
    indicatorSeparator: () => ({
        display: "none",
    }),
    loadingIndicator: (provided) => ({
        ...provided,
        color: "#4f46e5",
    }),
    loadingMessage: (provided) => ({
        ...provided,
        color: "#64748b",
        fontSize: "0.75rem",
        padding: "1rem",
        textAlign: "center",
    }),
    noOptionsMessage: (provided) => ({
        ...provided,
        color: "#64748b",
        fontSize: "0.75rem",
        padding: "1rem",
        textAlign: "center",
    }),
});
// const CSSForFilterDropdown = {
//     control: (provided, state) => ({
//         ...provided,
//         backgroundColor: "transparent",
//         border: "none",
//         boxShadow: "none",
//         minHeight: "42px",
//         cursor: "pointer",
//         '&:hover': {
//             backgroundColor: "transparent",
//         },
//         minWidth: "20vw",
//     }),
//     placeholder: (provided) => ({
//         ...provided,
//         color: "black",
//         fontSize: "1em",
//     }),
//     valueContainer: (provided) => ({
//         ...provided,
//         padding: "0.25rem 0.75rem",
//     }),
//     input: (provided) => ({
//         ...provided,
//         color: "#1e293b",
//         fontSize: "0.8125rem",
//         margin: 0,
//         padding: 0,
//     }),
//     singleValue: (provided) => ({
//         ...provided,
//         color: "#1e293b",
//         fontSize: "0.8125rem",
//         fontWeight: 500,
//     }),
//     menu: (provided) => ({
//         ...provided,
//         // zIndex: 999, // Increased from 2
//         borderRadius: "0.75rem",
//         boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
//         marginTop: "4px",
//         overflow: "hidden",
//         animation: "dropdownSlide 0.2s ease-out",
//         position: "absolute", // Ensure absolute positioning
//     }),
//     menuPortal: (base) => ({
//         ...base,
//         // zIndex: 999, // Increased from 2
//     }),
//     menuList: (provided) => ({
//         ...provided,
//         padding: "0.25rem",
//         maxHeight: "280px",
//         '&::-webkit-scrollbar': {
//             width: "4px",
//         },
//         '&::-webkit-scrollbar-track': {
//             background: "#f1f5f9",
//             borderRadius: "2px",
//         },
//         '&::-webkit-scrollbar-thumb': {
//             background: "#cbd5e1",
//             borderRadius: "2px",
//         },
//     }),
//     option: (provided, state) => ({
//         ...provided,
//         fontSize: "0.8125rem",
//         padding: "0.625rem 0.75rem",
//         borderRadius: "0.5rem",
//         width: "85%",
//         margin: "0.125rem",
//         color: state.isSelected ? "#ffffff" : "#1e293b",
//         backgroundColor: state.isSelected ? "black" : state.isFocused ? "#f1f5f9" : "#ffffff",
//         cursor: "pointer",
//         transition: "all 0.2s",
//         "&:hover": {
//             backgroundColor: state.isSelected ? "black" : "#f1f5f9",
//         },
//     }),
//     dropdownIndicator: (provided, state) => ({
//         ...provided,
//         color: "#94a3b8",
//         padding: "0.5rem",
//         cursor: "pointer",
//         transition: "transform 0.2s ease",
//         transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : "rotate(0deg)",
//         "&:hover": {
//             color: "#4f46e5",
//         },
//     }),
//     clearIndicator: (provided) => ({
//         ...provided,
//         color: "#94a3b8",
//         padding: "0.5rem",
//         cursor: "pointer",
//         "&:hover": {
//             color: "#ef4444",
//         },
//     }),
//     indicatorSeparator: () => ({
//         display: "none",
//     }),
//     loadingIndicator: (provided) => ({
//         ...provided,
//         color: "#4f46e5",
//     }),
//     loadingMessage: (provided) => ({
//         ...provided,
//         color: "#64748b",
//         fontSize: "0.75rem",
//         padding: "1rem",
//         textAlign: "center",
//     }),
//     noOptionsMessage: (provided) => ({
//         ...provided,
//         color: "#64748b",
//         fontSize: "0.75rem",
//         padding: "1rem",
//         textAlign: "center",
//     }),
// };

const CSSForSelect = {
    control: (provided) => ({
        ...provided,
        width: '34vw',
        minWidth: '34vw',
        height: '50px',
        borderRadius: '10px',
        border: '1px solid #e3e3e3',
        margin: '10px 0px 20px 0px',
        color: '#4a4a4a',
        backgroundColor: '#f7f8fa',
        padding: '0px 10px',
        textTransform: "capitalize",
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#4a4a4a',
        textTransform: "capitalize",
    }),
    menu: (provided) => ({
        ...provided,
        width: '34vw',
        minWidth: '34vw',
        borderRadius: '10px',
        marginTop: '0',
        zIndex: 5,
    }),
    menuList: (provided) => ({
        ...provided,
        width: '34vw',
        minWidth: '34vw',
        padding: 0,
    }),
    menuPortal: (provided) => ({
        ...provided,
        zIndex: 9999,
    }),
    singleValue: (provided) => ({
        ...provided,
        color: '#4a4a4a',
        textTransform: "capitalize",
    }),
    input: (provided) => ({
        ...provided,
        color: '#4a4a4a',
        textTransform: "capitalize",
    }),
    option: (provided, state) => ({
        ...provided,
        textTransform: "capitalize",
        backgroundColor: state.isFocused ? "#e6f0ff" : "#fff",
        color: '#4a4a4a',
    }),
};


// const Lock = ({ apiName, id, i, getData, usedFor }) => {
//     const [lock, setLock] = useState(false);
//     const [show, setShow] = useState(false);
//     const [data, setData] = useState([]);
//     const [showGif, setShowGif] = useState(false); // ✅ new state for gif

//     const handleShow = () => {
//         setShow(true);
//         setData(i);
//         setLock(i.lock);
//     };

//     const handleClose = () => setShow(false);

//     const handleInputChange = (e) => {
//         setLock(e.target.checked);
//     };




//     console.log("i")
//     console.log(i.lock)
//     console.log(lock)
//     const handleSubmit = async () => {
//         try {
//             const response = await axiosInstance.put(
//                 `/siteproject/${apiName}/${id}/`,
//                 { lock }
//             );

//             if (usedFor === "Letter") {
//                 setLock(response.data.letter_record.lock);

//             }
//             else {
//                 setLock(response.data.lock);

//             }

//             if (response.status === 200) {
//                 setShowGif(true); // ✅ show GIF

//                 setTimeout(() => {
//                     setShowGif(false); // ✅ hide after 2s
//                     handleClose();     // ✅ close modal
//                     getData();         // ✅ fetch data after modal closes

//                 }, 5400);

//             }
//         } catch (error) {
//             console.error("Error updating lock:", error);
//         }
//     };

//     return (
//         <>
//             <button onClick={handleShow} className="model-delete-button-modern actionn-icon" style={{ margin: "0px 10px", backgroundColor: i.lock === true ? "#2576bc" : "#f72b50" }}>

//                 {i.lock === true ? (
//                     <LockButton handleShow={handleShow} />
//                 ) : (
//                     <UnLockButton handleShow={handleShow} />
//                 )}
//             </button>
//             {showGif ? (
//                 <Modal show={show} backdrop="static" keyboard={false} centered>

//                     <Modal.Body >

//                         <div className="text-center"
//                         >
//                             {lock === true ?
//                                 <>
//                                     <img
//                                         src="https://cipl-aimantra.s3.amazonaws.com/documents/Lock_opens_and_turns_into_a_green_tick_1.gif"
//                                         alt="success"
//                                         style={{ width: "120px" }}
//                                     />
//                                     <p>{usedFor} Locked Successfully!</p>
//                                 </>

//                                 :
//                                 <>
//                                     <img
//                                         src="https://cipl-aimantra.s3.amazonaws.com/documents/Unlocked.gif"
//                                         alt="success"
//                                         style={{ width: "120px" }}
//                                     />
//                                     <p>{usedFor} Unlocked Successfully!</p>
//                                 </>
//                             }
//                         </div>
//                     </Modal.Body>
//                 </Modal>

//             ) : (
//                 <Modal show={show} onHide={handleClose}>
//                     <Modal.Header closeButton>
//                         <Modal.Title>{lock === false ? "Unlock" : "Lock"} {usedFor} Data</Modal.Title>
//                     </Modal.Header>
//                     <Modal.Body>

//                         <>
//                             <div
//                                 className="form-group Flex-row justify-center"
//                                 style={{ display: "flex" }}
//                             >
//                                 <div>
//                                     <label className="toggle-wrapper">
//                                         <input
//                                             type="checkbox"
//                                             name="lock"
//                                             className="toggle-input"
//                                             checked={lock}
//                                             onChange={handleInputChange}
//                                         />
//                                         <div className="toggle-track">
//                                             <svg
//                                                 className="toggle-icon lock"
//                                                 viewBox="0 0 100 100"
//                                             >
//                                                 <path d="M50,18A19.9,19.9,0,0,0,30,38v8a8,8,0,0,0-8,8V74a8,8,0,0,0,8,8H70a8,8,0,0,0,8-8V54a8,8,0,0,0-8-8H38V38a12,12,0,0,1,23.6-3,4,4,0,1,0,7.8-2A20.1,20.1,0,0,0,50,18Z"></path>
//                                             </svg>
//                                             <svg
//                                                 className="toggle-icon unlock"
//                                                 viewBox="0 0 100 100"
//                                             >
//                                                 <path
//                                                     d="M30,46V38a20,20,0,0,1,40,0v8a8,8,0,0,1,8,8V74a8,8,0,0,1-8,8H30a8,8,0,0,1-8-8V54A8,8,0,0,1,30,46Zm32-8v8H38V38a12,12,0,0,1,24,0Z"
//                                                     fillRule="evenodd"
//                                                 ></path>
//                                             </svg>
//                                         </div>
//                                     </label>
//                                 </div>
//                             </div>

//                             <hr />
//                             <div
//                                 className="button-models"
//                                 style={{ justifyContent: "center" }}
//                             >
//                                 <button
//                                     className="model-button font-weight500 model-button-cancel"
//                                     onClick={handleClose}
//                                 >
//                                     Cancel
//                                 </button>
//                                 <button
//                                     type="submit"
//                                     className="model-button font-weight500 model-button-leave font-weight500 font-size-heading"
//                                     onClick={handleSubmit}
//                                 >
//                                     {lock === false ? "Unlock" : "Lock"}
//                                 </button>
//                             </div>
//                         </>

//                     </Modal.Body>
//                 </Modal>
//             )}
//         </>
//     );
// };


const Lock = ({ apiName, id, i, getData, usedFor }) => {
    const [lock, setLock] = useState(false);
    const [show, setShow] = useState(false);
    const [data, setData] = useState([]);
    const [showGif, setShowGif] = useState(false); // ✅ new state for gif

    const handleShow = () => {
        setShow(true);
        setData(i);
        setLock(i.lock);
    };

    const handleClose = () => setShow(false);

    const handleInputChange = (e) => {
        setLock(e.target.checked);
    };

    const handleSubmit = async () => {
        try {
            const response = await axiosInstance.put(
                `/siteproject/${apiName}/${id}/`,
                { lock }
            );

            if (usedFor === "Letter") {
                setLock(response.data.letter_record.lock);

            }
            else {
                setLock(response.data.lock);

            }

            if (response.status === 200) {
                setShowGif(true); // ✅ show GIF

                setTimeout(() => {
                    setShowGif(false); // ✅ hide after 2s
                    handleClose();     // ✅ close modal
                    getData();         // ✅ fetch data after modal closes

                }, 5400);

            }
        } catch (error) {
            console.error("Error updating lock:", error);
        }
    };

    return (
        <>
            <button onClick={handleShow} className="model-delete-button-modern actionn-icon" style={{ margin: "0px 10px", backgroundColor: i.lock === true ? "#2576bc" : "#f72b50" }}>

                {i.lock === true ? (
                    <LockButton handleShow={handleShow} />
                ) : (
                    <UnLockButton handleShow={handleShow} />
                )}
            </button>
            {showGif ? (
                <Modal show={show} backdrop="static" keyboard={false} centered dialogClassName="modern-required-modal">
                    <Modal.Body className="modern-modal-body requirement-modal-body">
                        <div className="text-center">
                            {lock === true ?
                                <>
                                    <img
                                        src="https://cipl-aimantra.s3.amazonaws.com/documents/Lock_opens_and_turns_into_a_green_tick_1.gif"
                                        alt="success"
                                        style={{ width: "120px" }}
                                    />
                                    <p>{usedFor} Locked Successfully!</p>
                                </>

                                :
                                <>
                                    <img
                                        src="https://cipl-aimantra.s3.amazonaws.com/documents/Unlocked.gif"
                                        alt="success"
                                        style={{ width: "120px" }}
                                    />
                                    <p>{usedFor} Unlocked Successfully!</p>
                                </>
                            }
                        </div>
                    </Modal.Body>
                </Modal>

            ) : (
                <Modal show={show} onHide={handleClose} dialogClassName="modern-required-modal" centered>
                    <Modal.Header className="modern-modal-header requirement-modal-header">
                        <div className="header-content">
                            <div className="requirement-header-icon">
                                {lock === false ? <UnlockIcon size={22} /> : <LockIcon size={22} />}
                            </div>
                            <div>
                                <Modal.Title>{lock === false ? "Unlock" : "Lock"} {usedFor} Data</Modal.Title>
                                <p className="header-subtitle" style={{ color: "white" }}>
                                    Confirm this action before proceeding
                                </p>
                            </div>
                        </div>
                        <button className="close-btn" onClick={handleClose}>
                            <X size={20} />
                        </button>
                    </Modal.Header>

                    <Modal.Body className="modern-modal-body requirement-modal-body">
                        <div className="requirement-mode-summary" style={{ marginBottom: '20px' }}>
                            <AlertCircle size={16} />
                            <span>
                                {lock === false
                                    ? `Unlocking will allow this ${usedFor.toLowerCase()} data to be edited again.`
                                    : `Locking will prevent this ${usedFor.toLowerCase()} data from being edited.`}
                            </span>
                        </div>

                        <div
                            className="form-group Flex-row justify-center"
                            style={{ display: "flex", marginBottom: '20px' }}
                        >
                            <div>
                                <label className="toggle-wrapper">
                                    <input
                                        type="checkbox"
                                        name="lock"
                                        className="toggle-input"
                                        checked={lock}
                                        onChange={handleInputChange}
                                    />
                                    <div className="toggle-track">
                                        <svg
                                            className="toggle-icon lock"
                                            viewBox="0 0 100 100"
                                        >
                                            <path d="M50,18A19.9,19.9,0,0,0,30,38v8a8,8,0,0,0-8,8V74a8,8,0,0,0,8,8H70a8,8,0,0,0,8-8V54a8,8,0,0,0-8-8H38V38a12,12,0,0,1,23.6-3,4,4,0,1,0,7.8-2A20.1,20.1,0,0,0,50,18Z"></path>
                                        </svg>
                                        <svg
                                            className="toggle-icon unlock"
                                            viewBox="0 0 100 100"
                                        >
                                            <path
                                                d="M30,46V38a20,20,0,0,1,40,0v8a8,8,0,0,1,8,8V74a8,8,0,0,1-8,8H30a8,8,0,0,1-8-8V54A8,8,0,0,1,30,46Zm32-8v8H38V38a12,12,0,0,1,24,0Z"
                                                fillRule="evenodd"
                                            ></path>
                                        </svg>
                                    </div>
                                </label>
                            </div>
                        </div>

                        <div className="submit-buttons" style={{ justifyContent: 'flex-end' }}>
                            <button type="button" className="btn-secondaryy" onClick={handleClose}>
                                Cancel
                            </button>
                            <button
                                type="submit"
                                className="btn-primaryy"
                                style={lock === false ? {} : { background: "#dc3545", borderColor: "#dc3545" }}
                                onClick={handleSubmit}
                            >
                                {lock === false ? <UnlockIcon size={18} /> : <LockIcon size={18} />}
                                <span>{lock === false ? "Unlock" : "Lock"}</span>
                            </button>
                        </div>

                        <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                    </Modal.Body>
                </Modal>
            )}
        </>
    );
};





const uploadFileInChunks = async (file, documentName, setUploadProgress) => {
    const totalChunks = Math.ceil(file.size / CHUNK_SIZE);
    const fileId = uuidv4(); // Unique file identifier


    for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex++) {
        const start = chunkIndex * CHUNK_SIZE;
        const end = Math.min(start + CHUNK_SIZE, file.size);
        const chunk = file.slice(start, end);

        const formData = new FormData();
        formData.append("document_name", documentName);
        formData.append("file", chunk);
        formData.append("chunk_index", chunkIndex);
        formData.append("total_chunks", totalChunks);
        formData.append("original_filename", file.name);
        formData.append("file_id", fileId);
        // formData.append("email", email);  // Send email with each chunk

        try {
            await axiosInstance2.post("/siteproject/upload-chunk/", formData,
                {
                    onUploadProgress: (progressEvent) => {
                        const percentCompleted = Math.round(
                            (progressEvent.loaded * 100) / progressEvent.total
                        );
                        setUploadProgress(percentCompleted);
                    },
                }
            )
        } catch (error) {
            console.error("Chunk upload failed:", error);
            return false;
        }
    }
    return fileId;
};
const ViewChatImageorFile = ({ doc, textcss, filesrc }) => {

    const isImage = (url) => {
        return /\.(jpg|jpeg|png|gif|bmp|webp)(\?.*)?$/.test(url);
    }
    return (
        <>
            <div className="flex-row justify-center">
                {isImage(filesrc) ? (
                    <a href={filesrc} target="_blank" rel="noopener noreferrer">
                        <img className="chat-photo" src={filesrc} alt={`File/ Image of ${getFileNameFromLink(filesrc)}`} />
                    </a>
                ) : (
                    <a href={filesrc} target="_blank" className={`${textcss ? textcss : ''}`} rel="noreferrer">
                        <DocumentIcon />
                        <br />
                        {getFileNameFromLink(filesrc)}
                    </a>
                )}
            </div>
        </>
    );
};


const FileDataReader = () => {
    const [file, setFile] = useState(null);
    const [extractedText, setExtractedText] = useState('');
    const [extractedData, setExtractedData] = useState({});
    const [isProcessing, setIsProcessing] = useState(false);
    const [customPatterns, setCustomPatterns] = useState([
        {
            name: 'dates',
            label: 'Dates',
            pattern: '/(\\d{1,2}[\\/\\-\\.]\\d{1,2}[\\/\\-\\.]\\d{2,4})|(\\d{4}[\\/\\-\\.]\\d{1,2}[\\/\\-\\.]\\d{1,2})|(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)[a-z]* \\d{1,2},? \\d{4}/gi',
            active: true
        },
        {
            name: 'names',
            label: 'Names',
            pattern: '/([A-Z][a-z]+ [A-Z][a-z]+)|([A-Z][a-z]+(?: [A-Z][a-z]+){1,2})/g',
            active: true
        },
        {
            name: 'phoneNumbers',
            label: 'Phone Numbers',
            pattern: '/(\\+\\d{1,3}[- ]?)?\\(?\\d{3}\\)?[- ]?\\d{3}[- ]?\\d{4}/g',
            active: true
        },
        {
            name: 'amounts',
            label: 'Monetary Amounts',
            pattern: '/\\$\\d{1,3}(?:,\\d{3})*(?:\\.\\d{2})?|\\d+ (dollars|USD)/gi',
            active: true
        },
        {
            name: 'emails',
            label: 'Email Addresses',
            pattern: '/[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}/g',
            active: true
        }
    ]);
    const [keywordPatterns, setKeywordPatterns] = useState([
        { text: 'invoice', active: true },
        { text: 'receipt', active: true },
        { text: 'contract', active: true },
        { text: 'agreement', active: true },
        { text: 'confidential', active: true },
        { text: 'urgent', active: true },
        { text: 'important', active: true },
        { text: 'deadline', active: true }
    ]);
    const [newPattern, setNewPattern] = useState({ name: '', label: '', pattern: '' });
    const [newKeyword, setNewKeyword] = useState('');

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        if (selectedFile) {
            setFile(selectedFile);
            extractFileData(selectedFile);
        }
    };

    const extractFileData = async (file) => {
        setIsProcessing(true);
        setExtractedData({});

        try {
            let text = '';

            if (file.type === 'text/plain') {
                text = await readTextFile(file);
            }
            else if (file.type === 'application/pdf') {
                text = await extractTextFromSimplePDF(file);
            }
            else {
                text = `File Name: ${file.name}\nFile Type: ${file.type}\nFile Size: ${(file.size / 1024).toFixed(2)} KB`;
            }

            setExtractedText(text);
            extractImportantData(text);
        } catch (error) {
            console.error('Extraction error:', error);
            setExtractedText(`Error processing file: ${error.message}`);
        } finally {
            setIsProcessing(false);
        }
    };

    const readTextFile = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = (event) => resolve(event.target.result);
            reader.onerror = (error) => reject(error);
            reader.readAsText(file);
        });
    };

    const extractTextFromSimplePDF = async (file) => {
        const arrayBuffer = await file.arrayBuffer();
        const uint8Array = new Uint8Array(arrayBuffer);
        let text = '';

        for (let i = 0; i < uint8Array.length; i++) {
            if (uint8Array[i] === 0x28) {
                i++;
                let charString = '';
                while (i < uint8Array.length && uint8Array[i] !== 0x29) {
                    charString += String.fromCharCode(uint8Array[i]);
                    i++;
                }
                text += charString + ' ';
            }
        }

        return text || "Couldn't extract text from PDF. This simple method only works for PDFs with text layers.";
    };

    const extractImportantData = (text) => {
        const results = {};


        customPatterns.forEach(pattern => {
            if (!pattern.active) return;

            try {
                const regex = new RegExp(pattern.pattern.slice(1, -2), pattern.pattern.slice(-2));
                const matches = [...new Set(text.match(regex) || [])];
                if (matches.length > 0) {
                    results[pattern.name] = {
                        label: pattern.label,
                        values: matches
                    };
                }
            } catch (e) {
                console.error(`Error processing pattern ${pattern.name}:`, e);
            }
        });


        const foundKeywords = [];
        keywordPatterns.forEach(keyword => {
            if (keyword.active && text.toLowerCase().includes(keyword.text.toLowerCase())) {
                foundKeywords.push(keyword.text);
            }
        });

        if (foundKeywords.length > 0) {
            results.keywords = {
                label: 'Keywords',
                values: [...new Set(foundKeywords)]
            };
        }

        setExtractedData(results);
    };

    const addNewPattern = () => {
        if (newPattern.name && newPattern.label && newPattern.pattern) {
            setCustomPatterns([
                ...customPatterns,
                {
                    ...newPattern,
                    active: true
                }
            ]);
            setNewPattern({ name: '', label: '', pattern: '' });
        }
    };

    const addNewKeyword = () => {
        if (newKeyword && !keywordPatterns.some(k => k.text.toLowerCase() === newKeyword.toLowerCase())) {
            setKeywordPatterns([
                ...keywordPatterns,
                {
                    text: newKeyword,
                    active: true
                }
            ]);
            setNewKeyword('');
        }
    };

    const togglePatternActive = (index) => {
        const updatedPatterns = [...customPatterns];
        updatedPatterns[index].active = !updatedPatterns[index].active;
        setCustomPatterns(updatedPatterns);
    };

    const toggleKeywordActive = (index) => {
        const updatedKeywords = [...keywordPatterns];
        updatedKeywords[index].active = !updatedKeywords[index].active;
        setKeywordPatterns(updatedKeywords);
    };

    const removePattern = (index) => {
        setCustomPatterns(customPatterns.filter((_, i) => i !== index));
    };

    const removeKeyword = (index) => {
        setKeywordPatterns(keywordPatterns.filter((_, i) => i !== index));
    };

    return (
        <div className="file-data-reader">
            <h2>Document Data Extractor</h2>

            <div className="upload-section">
                <input
                    type="file"
                    onChange={handleFileChange}
                    accept=".pdf,.txt"
                    disabled={isProcessing}
                />
                {isProcessing && <p>Processing file...</p>}
            </div>



            {extractedText && (
                <div className="text-preview">
                    <h3>File Content</h3>
                    <textarea readOnly value={extractedText} />
                </div>
            )}

            <div className="extracted-data">
                <h3>Extracted Data</h3>

                {Object.keys(extractedData).length === 0 ? (
                    <p>No data extracted yet. Upload a file to see results.</p>
                ) : (
                    Object.entries(extractedData).map(([key, data]) => (
                        <div className="data-section" key={key}>
                            <h4>{data.label}:</h4>
                            <ul>
                                {data.values.map((value, i) => (
                                    <li key={i}>{value}</li>
                                ))}
                            </ul>
                        </div>
                    ))
                )}
            </div>


        </div>
    );
};

const formatDate = (date) => {
    if (!date) return "-"; // handle null/undefined

    const d = new Date(date);
    if (isNaN(d)) return "-"; // handle invalid dates

    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0"); // months are 0-based
    const year = d.getFullYear();

    return `${day}-${month}-${year}`;
};



const AttachmentIcon = ({ source }) => {
    const ext = getFileExtension(source);

    if (isImage(source)) return <ImageIcon />;

    switch (ext) {
        case "pdf":
            return <PDFIcon />
        case "doc":
        case "docx":
            return <DOCIcon />
        case "xls":
        case "xlsx":
            return <EXCELIcon />
        case "mp4":
        case "avi":
        case "mov":
        case "mkv":
            return <VideoIcon />
        default:
            return <div title={source}>
                <DocumentIcon />
            </div>
    }
};




export {
    handleErrorToast,
    getMonthName,
    calculateTotal,
    getProgressColor,
    formatRoundoff,
    formatRoundoffComplete,
    formatRoundoff2D,
    formatRoundoff3D,
    formatRoundoffCrores,
    formatCurrencyIndian,
    formatDateTime,
    formatDate,
    formatExcelToJson,
    sortProjects,
    ascSortByKey,
    customSortByKey,
    downloadAsExcel,
    inputMaxLimit,
    inputMinLimit,
    getFileNameFromLink,
    ViewFile,
    ViewOtherFile,
    ViewReciept,
    ViewRequestStatus,
    ViewRequestRemarks,
    ViewDocumnetsbilling,
    ViewEmployeeList,
    isEditable,

    ViewDynamicApprovalDates,
    ViewDynamicApprovalStatus,
    ViewDynamicApprovalRemarks,

    ViewRequestStatusImprest,
    ViewRequestRemarksImprest,
    ViewRequestStatusExpense,
    ViewRequestRemarksExpense,
    HandleDownloadTableasExcel,
    DateRangePicker,
    uploadFileInChunks,
    ViewChatImageorFile,
    FileDataReader,
    CSSForSelect,
    CSSForSelectSmallWidth,
    CSSForSelect10vWWidth,
    CustomModel,
    calculateNextDate,
    CSSForFilterDropdown,
    CSSForFilterDropdown10VW,
    getCSSForFilterDropdown,
    subtractDaysFromDate,
    CSSForMultiSelectOption,
    CSSForMultiSelectOptionNew,
    CSSForSelect15vWWidth,
    CSSForSelectModern,
    CSSForSelectModern15VWWidth,
    CSSForSelectModern10VWWidth,
    CSSForSelect15vWWidthvwWithourforntSize,
    ProgressModal,
    getMonthOptionss,
    toOrdinal,
    isMoreThan24Hours,
    Lock,
    CSSForSelect20vWWidth,

    AttachmentIcon,
    DeleteButton,
    Addbutton,
    Updatebutton,
    CSSForSelect23vWWidth,
    ViewDynamicboqStatus,
};
